export type Language = "de" | "en" | "fr" | "es" | "it";

export const languageLabels: Record<Language, string> = {
  de: "Deutsch",
  en: "English",
  fr: "Français",
  es: "Español",
  it: "Italiano",
};

// Nested translation structure
export type Translations = typeof translations.de;

export const translations = {
  de: {
    nav: {
      home: "Home",
      hotel: "Hotel",
      rooms: "Rooms",
      restaurant: "Restaurant",
      badRagaz: "Bad Ragaz",
      contact: "Contact",
      bookNow: "Buchen",
    },
    hero: {
      welcome: "Willkommen im",
      hotelName: "Esos Hotel Quelle,",
      location: "Bad Ragaz",
    },
    ski: {
      title: "Skipass inklusive",
      subtitle: "ab 2 Übernachtungen",
      cta: "Mehr erfahren",
    },
    homeNews: {
      caption: "Neuigkeiten",
      heading: "Aktuelles aus dem Hotel Quelle",
      comingSoon: "Neuigkeiten folgen in Kürze – bleiben Sie gespannt!",
    },
    homeAbout: {
      caption: "Willkommen",
      heading1: "Hotel Quelle",
      heading2: "Bad Ragaz",
      text: "Im historischen Zentrum von Bad Ragaz gelegen, bietet das Hotel Quelle eine perfekte Kombination aus Schweizer Tradition und herzlicher Gastfreundschaft. Mit einer reichen Geschichte und exzellentem Service sind wir die ideale Wahl für Reisende, die Komfort und Authentizität suchen.",
      location: "Bad Ragaz",
      country: "Schweiz",
      reception: "Rezeption",
      cta: "Mehr Erfahren",
      aboutHeading: "Über das Hotel",
      shortText: "Willkommen in unserem charmanten Boutique-Hotel mit komfortablen Zimmern und Apartments in ruhiger Lage im Herzen von Bad Ragaz, direkt am Ufer des Flusses Tamina.",
    },
    guestfriend: {
      heading: "Entdecken Sie jetzt alle Informationen, Angebote",
      heading2: "und Tipps für Ihren Urlaub",
      partner: "In Kooperation mit",
      scan: "Scannen oder hier klicken",
    },
    badRagazSection: {
      heading: "Reine Natur",
      caption: "Entdecken Sie unsere Umgebung",
      subtitle: "Umgeben von den Alpen in der Ostschweiz, in der Region Heidiland",
      values: "Unsere Grundwerte: Jeden Tag ein frisches Frühstück, höchste Standards an Sauberkeit und optimaler Komfort für alle Gäste.",
      description: "Bad Ragaz ist ein renommierter Ort in der Ostschweiz, vertreten durch Heidiland Tourismus. Hier finden Sie eine uralte Thermalquelle, ein entspannendes Spa-Ziel und einen Kurort, umgeben von majestätischen Bergen und wunderschöner Natur zu allen Jahreszeiten. Der perfekte Ort, um Körper und Seele zu regenerieren.",
      cta: "Mehr über Bad Ragaz erfahren",
      winter: "Winter",
      spring: "Frühling",
      summer: "Sommer",
      autumn: "Herbst",
    },
    homeRooms: {
      caption: "Unterkunft",
      heading: "Unsere Zimmer",
      text: "Wählen Sie das passende Zimmer für Ihren komfortablen Aufenthalt.",
      moreDetails: "Mehr Details",
      familyRoom: "Standard Familienzimmer",
      tripleRoom: "Standard Dreibettzimmer",
      twinRoom: "Economy Doppelzimmer",
      doubleRoom: "Standard Doppelzimmer",
      suite: "Suite",
    },
    homeApartments: {
      caption: "Langzeitaufenthalt",
      heading: "Apartments",
      bookTitle: "Buchen Sie Ihr Apartment direkt bei uns",
      bookText: "Wir bieten Apartments zur Miete an, abhängig von der Verfügbarkeit. Jedes Apartment hat ein individuelles Layout und eine unterschiedliche Grösse. Reservierungen müssen direkt beim Hotel vorgenommen werden, da diese Unterkünfte nicht über Drittanbieter-Buchungswebseiten angeboten werden.",
      contactLink: "Kontaktieren Sie uns für weitere Informationen und Verfügbarkeit.",
      amenities: [
        "2–3 Schlafzimmer",
        "Kleine Küchenzeile",
        "Kabel- & Smart-TV",
        "Badezimmer",
        "Haartrockner",
        "Hotel-Pflegeprodukte",
        "Internet Wi-Fi",
        "Safe",
      ],
    },
    homeGallery: {
      caption: "Einblicke",
      heading: "Einige Hotelansichten",
    },
    homeDining: {
      caption: "Küche & Getränke",
      heading: "Kulinarisches Erlebnis",
      text: "Vom kontinentalen Frühstück bis zum traditionellen Grill – geniessen Sie unsere besonderen Geschmackserlebnisse.",
      breakfastTitle: "Buffet Breakfast & Dinner",
      breakfastText: "Wir servieren täglich frisches kontinentales Frühstück für alle unsere Hotelgäste in unserem schönen Speisesaal. Einige unserer Spezialitäten stammen direkt von unseren Partnerbauernhöfen.",
      breakfastTime: "Frühstück – 7:30 bis 9:30",
      dinnerTime: "Abendessen – 17:30 bis 19:30",
      grillTitle: "Esos Grill",
      grillText: "Esos Grill ist ein Restaurant, das mit dem Hotel verbunden ist.",
      grillHighlight: "Von Balkan-Tradition zu Schweizer Tradition",
      grillDesc: "bietet Esos Grill eine Vielfalt an gegrillten und Fast-Comfort-Food-Gerichten für alle Gäste.",
      grillHours: "Geöffnet von 17:30 bis 22:00",
      cta: "Restaurant Entdecken",
      cafeHeading: "Gemütliches Café serviert köstliche Speisen und Getränke",
    },
    footer: {
      home: "Startseite",
      about: "Über uns",
      rooms: "Zimmer",
      restaurant: "Restaurant",
      contact: "Kontakt",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      navigation: "Navigation",
      followUs: "Folgen Sie uns",
      legal: "Rechtliches",
      rights: "Alle Rechte vorbehalten.",
      designBy: "Design & Entwicklung von",
      reservation: "Reservation",
    },
    footerContact: {
      caption: "Ihr Aufenthalt beginnt hier",
      heading: "Kontaktieren Sie uns",
      whatsappAction: "Nachricht senden",
      address: "Adresse:",
      namePlaceholder: "Ihr Name",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon",
      subjectLabel: "Betreff",
      subjectPlaceholder: "Betreff wählen",
      messageLabel: "Nachricht",
      messagePlaceholder: "Wie können wir Ihnen helfen?",
      sending: "Wird gesendet...",
      sendMessage: "Nachricht Senden",
      privacyText: "Mit dem Absenden akzeptieren Sie unsere",
      privacyLink: "Datenschutzerklärung",
      subjects: {
        reservation: "Zimmerreservierung",
        restaurant: "Tischreservierung",
        group: "Gruppenreservierung",
        event: "Event / Konferenz",
        feedback: "Feedback",
        other: "Sonstiges",
      },
      toastTitle: "Nachricht gesendet!",
      toastDesc: "Vielen Dank für Ihre Nachricht. Wir werden uns bald bei Ihnen melden.",
    },
    // Subpage heroes
    subpageHeroes: {
      about: { title: "Über uns", subtitle: "Unser Hotel" },
      rooms: { title: "Unsere Zimmer", subtitle: "Komfort & Erholung" },
      restaurant: { title: "Restaurant", subtitle: "Kulinarisches Erlebnis" },
      badRagaz: { title: "Bad Ragaz", subtitle: "Spa Village – Schweiz" },
      contact: { title: "Kontakt", subtitle: "Wir freuen uns auf Sie" },
      familyRoom: { title: "Standard Familienzimmer", subtitle: "Standard Family Room" },
      tripleRoom: { title: "Standard Dreibettzimmer", subtitle: "Standard Triple Room" },
      twinRoom: { title: "Economy Doppelzimmer / Zweibettzimmer mit Gemeinschaft Bad/WC", subtitle: "Economy Double Room / Twin Room with Shared Bathroom" },
      doubleRoom: { title: "Standard Doppelzimmer", subtitle: "Standard Double Room" },
      suite: { title: "Suite", subtitle: "Suite" },
      bookingPolicy: { title: "Buchungsrichtlinien", subtitle: "Booking Policy" },
    },
    // About page
    about: {
      storyCaption: "Unsere Geschichte",
      storyHeading1: "Ein Zuhause fern",
      storyHeading2: "der Heimat –",
      storyHeading3: "seit 1918",
      storyText: "Unser charmantes Boutique-Hotel heisst seit über einem Jahrhundert Reisende aus aller Welt herzlich willkommen. Mit seiner reichen Geschichte und familiären Atmosphäre bietet das Hotel eine einzigartige Mischung aus traditionellem Charme und modernem Komfort.",
      founded: "Gegründet",
      yearsHospitality: "Jahre Gastfreundschaft",
      historicCaption: "Hotel Quelle – Historische Aufnahme, circa 1918",
      filmQuote: "Wir sind stolz darauf, im schweizerisch-amerikanischen Film",
      filmTitle: "Sew Torn",
      filmQuote2: "mitgewirkt zu haben – ein filmisches Vermächtnis, das unseren geschichtsträchtigen Mauern eine besondere Note verleiht.",
      filmWelcome: "Ob zur Erholung, zum Wellness oder zur Inspiration – Willkommen im Hotel Quelle",
      locationCaption: "Unsere Lage",
      locationHeading: "Eingebettet in eine friedliche, idyllische Umgebung",
      locationHeadingItalic: "entlang der historischen Tamina",
      taminaschlucht: "Taminaschlucht",
      taminaschluchtDesc: "Nur wenige Schritte entfernt befindet sich der Eingang zur atemberaubenden Taminaschlucht.",
      thermalSource: "Historische Thermalquelle",
      thermalSourceDesc: "Ein malerischer 45-minütiger Spaziergang führt zur historischen Thermalquellenhöhle – einst ein Zufluchtsort für Adlige und römische Eliten.",
      taminaTherme: "Tamina Therme",
      taminaThermeDesc: "Die weltberühmte Tamina Therme ist nur 3 Gehminuten von unserem Hotel entfernt.",
      centralLocation: "Zentrale Lage",
      centralLocationDesc: "Im Herzen von Bad Ragaz – nur eine Stunde östlich von Zürich und 10 Gehminuten vom Bahnhof entfernt.",
      amenitiesHeading: "Frisch renoviert, bieten unsere Zimmer und Apartments gemütliche Eleganz für einen wirklich komfortablen Aufenthalt.",
      modernFurnishing: "Moderne Einrichtung",
      modernFurnishingDesc: "Unsere Apartments verfügen über eine moderne Einrichtung, die Stil mit Komfort verbindet – für eine entspannte, elegante und zeitgemässe Atmosphäre.",
      privateBalconies: "Private Balkone",
      privateBalconiesDesc: "Jedes Apartment verfügt über einen privaten Balkon mit ruhigem Aussenbereich, frischer Luft, natürlicher Aussicht und privater Entspannung.",
      roomService: "Zimmerservice",
      roomServiceDesc: "Professioneller Zimmerservice sorgt täglich für Sauberkeit – damit Ihr Apartment frisch, gepflegt und einladend bleibt.",
      wifiTitle: "Internet & WLAN",
      wifiDesc: "Highspeed-WLAN steht Ihnen zur Verfügung – ideal für Arbeit, Surfen, Streaming oder Videoanrufe während Ihres Aufenthalts.",
      wellnessTitle: "Wellness Center",
      wellnessDesc: "Gäste können die Tamina Therme besuchen, nur 500m entfernt. Unsere Gäste erhalten 10% Rabatt auf den Eintrittspreis.",
      productsTitle: "Hotel-Pflegeprodukte",
      productsDesc: "Jedes Apartment ist mit hochwertigen Pflegeprodukten ausgestattet – für Komfort und Wohlbefinden während Ihres Aufenthalts.",
      galleryCaption: "Hotelgalerie",
      galleryHeading: "Entdecken Sie unser Hotel in Bad Ragaz",
    },
    // Rooms page
    roomsPage: {
      caption: "Unterkunft",
      heading: "Unsere Zimmer",
      text: "Wählen Sie das passende Zimmer für Ihren komfortablen Aufenthalt. Alle Zimmer beinhalten ein kostenloses Frühstück, WLAN, Smart TV und einen Gratis-Parkplatz.",
      familyRoom: "Standard Familienzimmer",
      familyRoomDesc: "Unser grösstes Zimmer – speziell für Familien gestaltet, mit reichlich Platz für alle.",
      tripleRoom: "Standard Dreibettzimmer",
      tripleRoomDesc: "Ideal für Freundesgruppen oder kleine Familien mit drei bequemen Betten.",
      twinRoom: "Economy Doppelzimmer",
      twinRoomDesc: "Perfekt für Kollegen oder Freunde – zwei getrennte Betten für maximale Flexibilität.",
      doubleRoom: "Standard Doppelzimmer",
      doubleRoomDesc: "Die ideale Wahl für Paare – komfortabel und elegant mit traditionellem Schweizer Charme.",
      suite: "Suite",
      suiteDesc: "Unsere geräumige Suite mit Küche, Kamin, Balkon und separatem Schlafbereich auf zwei Etagen.",
      upTo: "Bis zu",
      persons: "Personen",
      learnMore: "Mehr erfahren",
      bookDirect: "Buchen Sie direkt beim Hotel und profitieren Sie von flexiblen Tarifen und persönlichem Service.",
      inquireNow: "Jetzt anfragen",
      bookingPolicy: "Buchungsrichtlinien",
    },
    // Restaurant page
    restaurantPage: {
      caption: "Küche & Getränke",
      heading: "Kulinarisches Erlebnis",
      text: "Entdecken Sie die verschiedenen Geschmäcker, die wir anbieten - vom traditionellen Balkangrill bis zum Schweizer Kontinentalfrühstück. Jedes Gericht wird mit Hingabe und frischen Zutaten zubereitet.",
      everyMorning: "Jeden Morgen",
      continentalBreakfast: "Kontinentales Frühstück",
      breakfastText: "Jeden Tag servieren wir ein frisches kontinentales Frühstück für alle Hotelgäste in unserem schönen Speisesaal. Einige unserer Produkte kommen direkt von lokalen Partnerbauernhöfen.",
      breakfastTime: "Frühstück: 7:30 - 9:30",
      dinnerTime: "Abendessen: 17:30 - 19:30",
      ourGarden: "Unser Garten",
      grillGarden: "Grill Garden",
      grillGardenText: "In unserem schönen Garten können die Gäste frische Getränke und leckere Speisen in der Natur geniessen. Wir haben einen Holzkohlegrill-Bereich, der ein authentisches Grillererlebnis bietet.",
      grillGardenText2: "Das Aussenambiente ist perfekt für warme Sommertage, wo Sie sich im Schatten der Bäume entspannen und unsere Spezialitäten geniessen können.",
      charcoalGrill: "Holzkohlegrill",
      relaxedAmbience: "Entspanntes Ambiente",
      freshDrinks: "Frische Getränke",
      greenArea: "Grüner Bereich",
      openingHours: "Öffnungszeiten:",
      weatherOpen: "Bei schönem Wetter geöffnet",
      ourRestaurant: "Unser Restaurant",
      esosGrillDesc: "Esos Grill ist ein Restaurant, das direkt mit dem Hotel verbunden ist.",
      balkanToSwiss: "Von der Balkantradition zur Schweizer Tradition",
      esosGrillDesc2: "Esos Grill bietet eine Vielfalt an Grill- und Fast-Comfort-Food-Gerichten, um alle Gäste zufriedenzustellen.",
      seats: "40+ Plätze",
      guestInfo: "Informationen für Gäste",
      tableReservation: "Tischreservierung",
      tableReservationDesc: "Für grössere Gruppen empfehlen wir eine Vorabreservierung.",
      reserveTable: "Tisch Reservieren",
      nonGuests: "Für Nicht-Hotelgäste",
      nonGuestsDesc: "Esos Grill ist auch für Besucher geöffnet, die nicht im Hotel übernachten. Herzlich willkommen!",
      drinksBeer: "Getränke & Bier",
      drinksBeerDesc: "Wir bieten eine breite Auswahl an Schweizer Bieren und erfrischenden Getränken.",
    },
    // Contact page
    contactPage: {
      caption: "Kontakt",
      heading: "Wir freuen uns auf Sie",
      text: "Haben Sie Fragen oder möchten Sie eine Reservierung vornehmen? Kontaktieren Sie uns – unser Team ist gerne für Sie da.",
      mobile: "Mobil",
      email: "E-Mail",
      whatsapp: "WhatsApp",
      sendMessage: "Nachricht senden",
      msgHeading: "Nachricht senden",
      firstName: "Vorname",
      lastName: "Nachname",
      phone: "Telefon",
      subject: "Betreff",
      selectSubject: "Betreff auswählen",
      checkIn: "Check-in",
      checkOut: "Check-out",
      guests: "Gäste",
      count: "Anzahl",
      person: "Person",
      persons: "Personen",
      message: "Nachricht",
      messagePlaceholder: "Wie können wir Ihnen helfen?",
      sending: "Wird gesendet...",
      send: "Nachricht Senden",
      privacyText: "Mit dem Absenden dieses Formulars akzeptieren Sie unsere",
      privacyLink: "Datenschutzerklärung",
      address: "Adresse",
      openInMaps: "In Google Maps öffnen",
      receptionTitle: "Rezeption",
      receptionHours: "Öffnungszeiten",
      receptionValue: "07:00 - 22:00",
      checkInTime: "16:00 - 22:00",
      checkOutTime: "07:00 - 11:00",
      paymentTitle: "Zahlung",
      paymentMethods: "Bargeld (CHF, EUR), Visa, MasterCard, American Express, Banküberweisung",
      subjects: {
        reservation: "Zimmerreservierung",
        restaurant: "Tischreservierung",
        group: "Gruppenreservierung",
        event: "Event / Konferenz",
        feedback: "Feedback / Vorschläge",
        other: "Sonstiges",
      },
      toastTitle: "Nachricht gesendet!",
      toastDesc: "Vielen Dank für Ihre Nachricht. Wir werden uns bald bei Ihnen melden.",
    },
    // Bad Ragaz page
    badRagazPage: {
      regionCaption: "Unsere Region",
      heading: "Bad Ragaz",
      spaVillage: "– Spa Village",
      intro1: "Bad Ragaz ist eine kleine Stadt mit einer langen und reichen Geschichte im Kanton St. Gallen, in der östlichen Region der Schweiz, verbunden mit der Heidiland-Region. Der Ort ist bekannt für sein Spa- und Gesundheitsresort, umgeben von einer luxuriösen Landschaft und wunderbaren Bergen.",
      intro2: "Hier befindet sich die Tamina, die zur Taminaschlucht in Altes Bad Pfäfers führt – mit einer natürlichen heissen Quelle, die als eine der ersten natürlichen Spa-Destinationen seit der Ära des Heiligen Römischen Reiches bekannt ist, entdeckt von Paracelsus, einem Schweizer Pionier und Arzt der medizinischen Revolution der Renaissance.",
      intro3: "Viele namhafte Persönlichkeiten und Sportmannschaften haben Bad Ragaz besucht, darunter Roger Federer, der FC Liverpool und Borussia Dortmund.",
      accessInfo: "Bad Ragaz liegt nur etwa eine Stunde von Davos und St. Moritz entfernt, sowie in der Nähe von St. Gallen und Chur. Erreichbar aus den Nachbarländern Liechtenstein, Österreich, Deutschland und Italien mit dem Auto oder öffentlichen Verkehrsmitteln.",
      mapCaption: "Bad Ragaz – Kanton St. Gallen, Schweiz",
      discoverCaption: "Entdecken",
      discoverHeading: "Was Bad Ragaz zu bieten hat",
      taminaTherme: "Tamina Therme",
      taminaThermeDesc: "Die weltberühmte Tamina Therme ist nur 3 Gehminuten von unserem Hotel entfernt.",
      pizol: "Pizol – Ski & Wandern",
      pizolDesc: "Das Skigebiet und Wanderparadies Pizol mit der berühmten 5-Seen-Wanderung.",
      taminaschlucht: "Taminaschlucht",
      taminaschluchtDesc: "Der Eingang zur atemberaubenden Taminaschlucht – nur wenige Schritte entfernt.",
      golf: "Golfplätze",
      golfDesc: "Wunderschöne Golfplätze inmitten einer beeindruckenden Bergkulisse.",
      shopping: "Shopping & Kultur",
      shoppingDesc: "Skulpturenausstellungen, Restaurants, Shopping-Outlets und vieles mehr.",
      transport: "Zentrale Anbindung",
      transportDesc: "Direktzüge von Amsterdam, Brüssel, Frankfurt, Hamburg, Köln und Paris.",
      impressionsCaption: "Impressionen",
      impressionsHeading: "Bad Ragaz & Umgebung",
      videoCaption: "Imagefilm",
      videoHeading: "Bad Ragaz erleben",
    },
    // Booking Policy
    bookingPolicyPage: {
      caption: "Esos Hotel Quelle",
      heading: "Buchungsrichtlinien",
      text: "Transparenz ist uns wichtig. Hier finden Sie alle Informationen zu Zahlung, Stornierung und Gruppenreservierungen.",
      payment: "Zahlung",
      paymentText: "Esos Hotel Quelle erhebt den Gesamtbetrag vom Gast zum Zeitpunkt der Buchung.",
      cancellation: "Stornierung & Rückerstattung",
      cancellationText: "Direktbuchungen sind vollständig erstattungsfähig, wenn sie mindestens",
      cancellationBold: "3 Tage vor Anreise bis 16:00 Uhr",
      cancellationText2: "storniert werden.",
      cancellationNoShow: "Bei Stornierung nach Ablauf der kostenlosen Stornierungsfrist oder bei Nichterscheinen (No-Show) erfolgt keine Rückerstattung.",
      groupBookings: "Gruppenreservierungen",
      groupText: "Gruppenbuchungen (mehr als 2 Zimmer) können bis zu",
      groupBold: "7 Tage vor Anreise",
      groupText2: "kostenlos storniert werden.",
      importantNote: "Wichtiger Hinweis",
      importantText: "Nach Ablauf der kostenlosen Stornierungsfrist werden dem Gast",
      importantBold: "100 % des Aufenthaltsbetrages",
      importantText2: "berechnet.",
      overview: "Übersicht",
      singleFree: "Einzelbuchung – kostenlose Stornierung",
      singleValue: "Bis 3 Tage vor Anreise, 16:00 Uhr",
      groupFree: "Gruppenbuchung – kostenlose Stornierung",
      groupValue: "Bis 7 Tage vor Anreise",
      lateNoShow: "Nach Stornierungsfrist / No-Show",
      lateValue: "100 % Gebühr",
      paymentLabel: "Zahlung",
      paymentValue: "Gesamtbetrag bei Buchung",
    },
    // Room detail
    roomDetail: {
      ourRooms: "Unsere Zimmer",
      viewPhotos: "Fotos ansehen",
      bookDirect: "Wir freuen uns, Sie bei Ihrem nächsten Aufenthalt begrüssen zu dürfen! Buchen Sie direkt beim Hotel und profitieren Sie von flexiblen Tarifen, ohne versteckte Drittanbietergebühren – mit persönlichem Service.",
      note: "Bitte beachten Sie: Jedes Zimmer variiert in Grösse, Grundriss und Innenausstattung. Die Preise richten sich nach der Anzahl der Gäste pro Zimmer. Wir tun unser Bestes, um auf Ihre individuellen Wünsche einzugehen.",
      bookNow: "Jetzt Buchen",
      equipment: "Zimmerausstattung",
      hotelTimes: "Hotelzeiten",
      allRooms: "← Alle Zimmer ansehen",
    },
    homeFAQ: {
      caption: "FAQ",
      heading: "Häufig gestellte Fragen",
      text: "Hier finden Sie Antworten auf die häufigsten Fragen zu Ihrem Aufenthalt im Hotel Quelle.",
      q1: "Wie sind die Check-in und Check-out Zeiten?",
      a1: "Check-in ist ab 15:00 Uhr und Check-out bis 11:00 Uhr. Früher Check-in oder später Check-out kann auf Anfrage arrangiert werden, abhängig von der Verfügbarkeit.",
      q2: "Ist das Frühstück im Zimmerpreis inbegriffen?",
      a2: "Ja, ein frisches kontinentales Frühstück ist im Zimmerpreis inbegriffen. Das Frühstück wird täglich von 7:30 bis 9:30 Uhr serviert.",
      q3: "Gibt es Parkmöglichkeiten beim Hotel?",
      a3: "Ja, wir bieten kostenlose Parkplätze für unsere Gäste. Bitte informieren Sie uns bei der Buchung, wenn Sie mit dem Auto anreisen.",
      q4: "Ist das Hotel für Familien mit Kindern geeignet?",
      a4: "Absolut! Wir haben Family Rooms, die ideal für Familien sind. Kinder sind herzlich willkommen und wir können auf Anfrage zusätzliche Betten bereitstellen.",
      q5: "Wie weit ist der Bahnhof Bad Ragaz entfernt?",
      a5: "Der Bahnhof Bad Ragaz ist nur etwa 5 Gehminuten vom Hotel entfernt. Wir können auch einen Transfer vom Bahnhof arrangieren.",
      q6: "Kann ich im Esos Grill Restaurant essen, auch wenn ich kein Hotelgast bin?",
      a6: "Ja, das Esos Grill Restaurant ist sowohl für Hotelgäste als auch für externe Besucher geöffnet. Reservierungen werden empfohlen, besonders am Wochenende.",
    },
    homeLocation: {
      caption: "Lage",
      heading: "Bad Ragaz,",
      headingItalic: "Schweiz",
      text: "Bad Ragaz liegt im Kanton St. Gallen im östlichen Teil der Schweiz. Bekannt für seine Thermalquellen und atemberaubenden Alpenaussichten, bietet die Stadt eine perfekte Kombination aus Natur und Kultur.",
      travel: "Anreise",
      byTrain: "Mit dem Zug",
      trainDesc: "Bahnhof Bad Ragaz - 5 Min. zu Fuss",
      byPlane: "Mit dem Flugzeug",
      planeDesc: "Flughafen Zürich - 1.5 Stunden",
      byCar: "Mit dem Auto",
      carDesc: "Autobahn A13 - Ausfahrt Bad Ragaz",
      contactUs: "Kontaktieren Sie uns",
    },
    roomData: {
      features: ["Kühlschrank", "Cable & Smart TV", "Eigenes Badezimmer", "Haartrockner", "Hotel-Pflegeprodukte", "Internet & WLAN", "Safe", "Gratis Parkplatz"],
      family: {
        amenities: ["Doppelbett, Einzelbett und Sofabett", "Eigenes Badezimmer mit Badewanne", "Cable & Smart TV", "Kostenloses WLAN", "Gratis Parkplatz"],
        highlight: "Privater Balkon",
        highlightSub: "Mit Blick auf die Tamina",
      },
      triple: {
        amenities: ["Doppelbett & Einzelbett", "Eigenes Badezimmer", "Cable & Smart TV", "Kostenloses WLAN", "Gratis Parkplatz"],
        highlight: "Komfortabler Schlafbereich",
        highlightSub: "Platz für bis zu 3 Gäste",
      },
      twin: {
        amenities: ["Doppelbett oder zwei Einzelbetten/Sofabett", "Etagen Gemeinschaft Bad/WC", "Cable & Smart TV", "Kostenloses WLAN", "Gratis Parkplatz"],
        highlight: "Komfortabler Schlafbereich",
        highlightSub: "Ideal für 2 Gäste",
      },
      double: {
        amenities: ["Komfortables Doppelbett", "Eigenes Badezimmer", "Cable & Smart TV", "Kostenloses WLAN", "Gratis Parkplatz"],
        highlight: "Gemütlicher Schlafbereich",
        highlightSub: "Komfort für 2 Gäste",
      },
      suite: {
        amenities: ["2 Doppelbetten und 1 Einzelbett mit 2/3 Schlafzimmer", "Eigenes Badezimmer", "Küche", "Kamin", "Balkon"],
        highlight: "Gemütlicher Kamin",
        highlightSub: "Entspannung auf zwei Etagen",
      },
    },
    hotelInfo: {
      heading: "Wichtige Hotel-Informationen",
      items: [
        "Kurtaxe/Tourismusabgabe CHF 4.60 pro Person / Nacht",
        "MWST 3.8%",
        "Extra Handtuch für Tamina Therme CHF 5.–",
        "Hund CHF 40.–/Tag",
        "Kostenlos für Kinder unter 4 Jahren, inkl. Babybett",
        "Parkplatz: Gratis",
        "Wichtig: Hotelparkplätze sind auf First-come-first-served-Basis verfügbar (begrenzte Verfügbarkeit).",
        "Zusätzliche Parkplätze im Parkhaus Zentrum für ca. CHF 1.–/Stunde (1–2 Minuten Fussweg).",
        "Kostenloses WLAN",
      ] as readonly string[],
      checkOut: "Check-out: 07:00 - 11:00",
      checkIn: "Check-in: 16:00 - 22:00",
      viewRooms: "Zimmer ansehen",
    },
  },

  en: {
    nav: {
      home: "Home",
      hotel: "Hotel",
      rooms: "Rooms",
      restaurant: "Restaurant",
      badRagaz: "Bad Ragaz",
      contact: "Contact",
      bookNow: "Book Now",
    },
    hero: {
      welcome: "Welcome to",
      hotelName: "Esos Hotel Quelle,",
      location: "Bad Ragaz",
    },
    ski: {
      title: "Ski Pass Included",
      subtitle: "from 2 nights",
      cta: "Learn more",
    },
    homeNews: {
      caption: "News",
      heading: "Latest from Hotel Quelle",
      comingSoon: "News coming soon – stay tuned!",
    },
    homeAbout: {
      caption: "Welcome",
      heading1: "Hotel Quelle",
      heading2: "Bad Ragaz",
      text: "Located in the historic center of Bad Ragaz, Hotel Quelle offers a perfect combination of Swiss tradition and warm hospitality. With a rich history and excellent service, we are the ideal choice for travelers seeking comfort and authenticity.",
      location: "Bad Ragaz",
      country: "Switzerland",
      reception: "Reception",
      cta: "Learn More",
      aboutHeading: "About the Hotel",
      shortText: "Welcome to our charming boutique hotel with comfortable rooms and apartments in a quiet location in the heart of Bad Ragaz, right on the banks of the Tamina river.",
    },
    guestfriend: {
      heading: "Discover all information, offers",
      heading2: "and tips for your holiday",
      partner: "In cooperation with",
      scan: "Scan or click here",
    },
    badRagazSection: {
      heading: "Pure Nature",
      caption: "Discover our surroundings",
      subtitle: "Surrounded by the Alps in Eastern Switzerland, in the Heidiland region",
      values: "Our core values: A fresh breakfast every day, highest standards of cleanliness and optimal comfort for all guests.",
      description: "Bad Ragaz is a renowned place in Eastern Switzerland, represented by Heidiland Tourism. Here you will find an ancient thermal spring, a relaxing spa destination and a health resort, surrounded by majestic mountains and beautiful nature in all seasons. The perfect place to regenerate body and soul.",
      cta: "Learn more about Bad Ragaz",
      winter: "Winter",
      spring: "Spring",
      summer: "Summer",
      autumn: "Autumn",
    },
    homeRooms: {
      caption: "Accommodation",
      heading: "Our Rooms",
      text: "Choose the right room for your comfortable stay.",
      moreDetails: "More Details",
      familyRoom: "Standard Family Room",
      tripleRoom: "Standard Triple Room",
      twinRoom: "Economy Double Room",
      doubleRoom: "Standard Double Room",
      suite: "Suite",
    },
    homeApartments: {
      caption: "Long-term Stay",
      heading: "Apartments",
      bookTitle: "Book your apartment directly with us",
      bookText: "We offer apartments for rent, subject to availability. Each apartment has an individual layout and different size. Reservations must be made directly with the hotel, as these accommodations are not offered through third-party booking websites.",
      contactLink: "Contact us for more information and availability.",
      amenities: [
        "2–3 Bedrooms",
        "Small Kitchenette",
        "Cable & Smart TV",
        "Bathroom",
        "Hair Dryer",
        "Hotel Toiletries",
        "Internet Wi-Fi",
        "Safe",
      ],
    },
    homeGallery: {
      caption: "Insights",
      heading: "Hotel Views",
    },
    homeDining: {
      caption: "Food & Drinks",
      heading: "Culinary Experience",
      text: "From continental breakfast to traditional grill – enjoy our special culinary experiences.",
      breakfastTitle: "Buffet Breakfast & Dinner",
      breakfastText: "We serve fresh continental breakfast daily for all our hotel guests in our beautiful dining room. Some of our specialties come directly from our partner farms.",
      breakfastTime: "Breakfast – 7:30 to 9:30",
      dinnerTime: "Dinner – 17:30 to 19:30",
      grillTitle: "Esos Grill",
      grillText: "Esos Grill is a restaurant connected to the hotel.",
      grillHighlight: "From Balkan Tradition to Swiss Tradition",
      grillDesc: "Esos Grill offers a variety of grilled and fast comfort food dishes for all guests.",
      grillHours: "Open from 17:30 to 22:00",
      cta: "Discover Restaurant",
      cafeHeading: "Cozy café serving delicious food and drinks",
    },
    footer: {
      home: "Home",
      about: "About Us",
      rooms: "Rooms",
      restaurant: "Restaurant",
      contact: "Contact",
      impressum: "Imprint",
      datenschutz: "Privacy Policy",
      navigation: "Navigation",
      followUs: "Follow Us",
      legal: "Legal",
      rights: "All rights reserved.",
      designBy: "Design & Development by",
      reservation: "Reservation",
    },
    footerContact: {
      caption: "Your stay starts here",
      heading: "Contact Us",
      whatsappAction: "Send message",
      address: "Address:",
      namePlaceholder: "Your Name",
      emailLabel: "Email",
      phoneLabel: "Phone",
      subjectLabel: "Subject",
      subjectPlaceholder: "Choose subject",
      messageLabel: "Message",
      messagePlaceholder: "How can we help you?",
      sending: "Sending...",
      sendMessage: "Send Message",
      privacyText: "By submitting you accept our",
      privacyLink: "Privacy Policy",
      subjects: {
        reservation: "Room Reservation",
        restaurant: "Table Reservation",
        group: "Group Reservation",
        event: "Event / Conference",
        feedback: "Feedback",
        other: "Other",
      },
      toastTitle: "Message sent!",
      toastDesc: "Thank you for your message. We will get back to you soon.",
    },
    subpageHeroes: {
      about: { title: "About Us", subtitle: "Our Hotel" },
      rooms: { title: "Our Rooms", subtitle: "Comfort & Relaxation" },
      restaurant: { title: "Restaurant", subtitle: "Culinary Experience" },
      badRagaz: { title: "Bad Ragaz", subtitle: "Spa Village – Switzerland" },
      contact: { title: "Contact", subtitle: "We Look Forward to Hearing from You" },
      familyRoom: { title: "Standard Family Room", subtitle: "Standard Family Room" },
      tripleRoom: { title: "Standard Triple Room", subtitle: "Standard Triple Room" },
      twinRoom: { title: "Economy Double Room / Twin Room with Shared Bathroom", subtitle: "Economy Double Room / Twin Room with Shared Bathroom" },
      doubleRoom: { title: "Standard Double Room", subtitle: "Standard Double Room" },
      suite: { title: "Suite", subtitle: "Suite" },
      bookingPolicy: { title: "Booking Policy", subtitle: "Booking Policy" },
    },
    about: {
      storyCaption: "Our Story",
      storyHeading1: "A Home Away",
      storyHeading2: "from Home –",
      storyHeading3: "since 1918",
      storyText: "Our charming boutique hotel has been welcoming travelers from around the world for over a century. With its rich history and family atmosphere, the hotel offers a unique blend of traditional charm and modern comfort.",
      founded: "Founded",
      yearsHospitality: "Years of Hospitality",
      historicCaption: "Hotel Quelle – Historic photograph, circa 1918",
      filmQuote: "We are proud to have been featured in the Swiss-American film",
      filmTitle: "Sew Torn",
      filmQuote2: "– a cinematic legacy that adds a special touch to our historic walls.",
      filmWelcome: "Whether for relaxation, wellness or inspiration – Welcome to Hotel Quelle",
      locationCaption: "Our Location",
      locationHeading: "Nestled in a peaceful, idyllic setting",
      locationHeadingItalic: "along the historic Tamina",
      taminaschlucht: "Tamina Gorge",
      taminaschluchtDesc: "Just a few steps away lies the entrance to the breathtaking Tamina Gorge.",
      thermalSource: "Historic Thermal Spring",
      thermalSourceDesc: "A scenic 45-minute walk leads to the historic thermal spring cave – once a refuge for nobility and Roman elites.",
      taminaTherme: "Tamina Therme",
      taminaThermeDesc: "The world-famous Tamina Therme is just a 3-minute walk from our hotel.",
      centralLocation: "Central Location",
      centralLocationDesc: "In the heart of Bad Ragaz – just one hour east of Zurich and a 10-minute walk from the train station.",
      amenitiesHeading: "Freshly renovated, our rooms and apartments offer cozy elegance for a truly comfortable stay.",
      modernFurnishing: "Modern Furnishing",
      modernFurnishingDesc: "Our apartments feature modern furnishings that combine style with comfort – for a relaxed, elegant and contemporary atmosphere.",
      privateBalconies: "Private Balconies",
      privateBalconiesDesc: "Each apartment has a private balcony with a quiet outdoor area, fresh air, natural views and private relaxation.",
      roomService: "Room Service",
      roomServiceDesc: "Professional room service ensures daily cleanliness – keeping your apartment fresh, well-maintained and inviting.",
      wifiTitle: "Internet & WiFi",
      wifiDesc: "High-speed WiFi is available – ideal for work, browsing, streaming or video calls during your stay.",
      wellnessTitle: "Wellness Center",
      wellnessDesc: "Guests can visit the Tamina Therme, just 500m away. Our guests receive a 10% discount on the entrance fee.",
      productsTitle: "Hotel Toiletries",
      productsDesc: "Each apartment is equipped with high-quality toiletries – for comfort and well-being during your stay.",
      galleryCaption: "Hotel Gallery",
      galleryHeading: "Discover our hotel in Bad Ragaz",
    },
    roomsPage: {
      caption: "Accommodation",
      heading: "Our Rooms",
      text: "Choose the right room for your comfortable stay. All rooms include complimentary breakfast, WiFi, Smart TV and free parking.",
      familyRoom: "Standard Family Room",
      familyRoomDesc: "Our largest room – specially designed for families, with plenty of space for everyone.",
      tripleRoom: "Standard Triple Room",
      tripleRoomDesc: "Ideal for groups of friends or small families with three comfortable beds.",
      twinRoom: "Economy Double Room",
      twinRoomDesc: "Perfect for colleagues or friends – two separate beds for maximum flexibility.",
      doubleRoom: "Standard Double Room",
      doubleRoomDesc: "The ideal choice for couples – comfortable and elegant with traditional Swiss charm.",
      suite: "Suite",
      suiteDesc: "Our spacious suite with kitchen, fireplace, balcony and separate sleeping area on two floors.",
      upTo: "Up to",
      persons: "persons",
      learnMore: "Learn more",
      bookDirect: "Book directly with the hotel and benefit from flexible rates and personal service.",
      inquireNow: "Inquire Now",
      bookingPolicy: "Booking Policy",
    },
    restaurantPage: {
      caption: "Food & Drinks",
      heading: "Culinary Experience",
      text: "Discover the different flavors we offer – from traditional Balkan grill to Swiss continental breakfast. Every dish is prepared with dedication and fresh ingredients.",
      everyMorning: "Every Morning",
      continentalBreakfast: "Continental Breakfast",
      breakfastText: "Every day we serve a fresh continental breakfast for all hotel guests in our beautiful dining room. Some of our products come directly from local partner farms.",
      breakfastTime: "Breakfast: 7:30 - 9:30",
      dinnerTime: "Dinner: 17:30 - 19:30",
      ourGarden: "Our Garden",
      grillGarden: "Grill Garden",
      grillGardenText: "In our beautiful garden, guests can enjoy fresh drinks and delicious food in nature. We have a charcoal grill area that provides an authentic grilling experience.",
      grillGardenText2: "The outdoor ambience is perfect for warm summer days, where you can relax in the shade of the trees and enjoy our specialties.",
      charcoalGrill: "Charcoal Grill",
      relaxedAmbience: "Relaxed Ambience",
      freshDrinks: "Fresh Drinks",
      greenArea: "Green Area",
      openingHours: "Opening hours:",
      weatherOpen: "Open in good weather",
      ourRestaurant: "Our Restaurant",
      esosGrillDesc: "Esos Grill is a restaurant directly connected to the hotel.",
      balkanToSwiss: "From Balkan Tradition to Swiss Tradition",
      esosGrillDesc2: "Esos Grill offers a variety of grill and fast comfort food dishes to satisfy all guests.",
      seats: "40+ Seats",
      guestInfo: "Guest Information",
      tableReservation: "Table Reservation",
      tableReservationDesc: "For larger groups we recommend a prior reservation.",
      reserveTable: "Reserve Table",
      nonGuests: "For Non-Hotel Guests",
      nonGuestsDesc: "Esos Grill is also open for visitors who are not staying at the hotel. Welcome!",
      drinksBeer: "Drinks & Beer",
      drinksBeerDesc: "We offer a wide selection of Swiss beers and refreshing beverages.",
    },
    contactPage: {
      caption: "Contact",
      heading: "We Look Forward to Hearing from You",
      text: "Do you have questions or would you like to make a reservation? Contact us – our team is happy to help.",
      mobile: "Mobile",
      email: "Email",
      whatsapp: "WhatsApp",
      sendMessage: "Send message",
      msgHeading: "Send Message",
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone",
      subject: "Subject",
      selectSubject: "Select subject",
      checkIn: "Check-in",
      checkOut: "Check-out",
      guests: "Guests",
      count: "Count",
      person: "Person",
      persons: "Persons",
      message: "Message",
      messagePlaceholder: "How can we help you?",
      sending: "Sending...",
      send: "Send Message",
      privacyText: "By submitting this form you accept our",
      privacyLink: "Privacy Policy",
      address: "Address",
      openInMaps: "Open in Google Maps",
      receptionTitle: "Reception",
      receptionHours: "Opening hours",
      receptionValue: "07:00 - 22:00",
      checkInTime: "16:00 - 22:00",
      checkOutTime: "07:00 - 11:00",
      paymentTitle: "Payment",
      paymentMethods: "Cash (CHF, EUR), Visa, MasterCard, American Express, Bank Transfer",
      subjects: {
        reservation: "Room Reservation",
        restaurant: "Table Reservation",
        group: "Group Reservation",
        event: "Event / Conference",
        feedback: "Feedback / Suggestions",
        other: "Other",
      },
      toastTitle: "Message sent!",
      toastDesc: "Thank you for your message. We will get back to you soon.",
    },
    badRagazPage: {
      regionCaption: "Our Region",
      heading: "Bad Ragaz",
      spaVillage: "– Spa Village",
      intro1: "Bad Ragaz is a small town with a long and rich history in the Canton of St. Gallen, in the eastern region of Switzerland, connected to the Heidiland region. The town is known for its spa and health resort, surrounded by a luxurious landscape and wonderful mountains.",
      intro2: "Here is the Tamina, which leads to the Tamina Gorge in Altes Bad Pfäfers – with a natural hot spring known as one of the first natural spa destinations since the era of the Holy Roman Empire, discovered by Paracelsus, a Swiss pioneer and physician of the Renaissance medical revolution.",
      intro3: "Many notable personalities and sports teams have visited Bad Ragaz, including Roger Federer, FC Liverpool and Borussia Dortmund.",
      accessInfo: "Bad Ragaz is only about an hour from Davos and St. Moritz, and near St. Gallen and Chur. Accessible from neighboring countries Liechtenstein, Austria, Germany and Italy by car or public transport.",
      mapCaption: "Bad Ragaz – Canton of St. Gallen, Switzerland",
      discoverCaption: "Discover",
      discoverHeading: "What Bad Ragaz has to offer",
      taminaTherme: "Tamina Therme",
      taminaThermeDesc: "The world-famous Tamina Therme is just a 3-minute walk from our hotel.",
      pizol: "Pizol – Skiing & Hiking",
      pizolDesc: "The ski resort and hiking paradise Pizol with the famous 5-Lakes Hike.",
      taminaschlucht: "Tamina Gorge",
      taminaschluchtDesc: "The entrance to the breathtaking Tamina Gorge – just a few steps away.",
      golf: "Golf Courses",
      golfDesc: "Beautiful golf courses amidst an impressive mountain backdrop.",
      shopping: "Shopping & Culture",
      shoppingDesc: "Sculpture exhibitions, restaurants, shopping outlets and much more.",
      transport: "Central Connections",
      transportDesc: "Direct trains from Amsterdam, Brussels, Frankfurt, Hamburg, Cologne and Paris.",
      impressionsCaption: "Impressions",
      impressionsHeading: "Bad Ragaz & Surroundings",
      videoCaption: "Image Film",
      videoHeading: "Experience Bad Ragaz",
    },
    bookingPolicyPage: {
      caption: "Esos Hotel Quelle",
      heading: "Booking Policy",
      text: "Transparency is important to us. Here you will find all information about payment, cancellation and group reservations.",
      payment: "Payment",
      paymentText: "Esos Hotel Quelle charges the total amount from the guest at the time of booking.",
      cancellation: "Cancellation & Refund",
      cancellationText: "Direct bookings are fully refundable if cancelled at least",
      cancellationBold: "3 days before arrival by 4:00 PM",
      cancellationText2: ".",
      cancellationNoShow: "No refund will be given for cancellations after the free cancellation period or for no-shows.",
      groupBookings: "Group Reservations",
      groupText: "Group bookings (more than 2 rooms) can be cancelled free of charge up to",
      groupBold: "7 days before arrival",
      groupText2: ".",
      importantNote: "Important Note",
      importantText: "After the free cancellation period, the guest will be charged",
      importantBold: "100% of the stay amount",
      importantText2: ".",
      overview: "Overview",
      singleFree: "Single booking – free cancellation",
      singleValue: "Up to 3 days before arrival, 4:00 PM",
      groupFree: "Group booking – free cancellation",
      groupValue: "Up to 7 days before arrival",
      lateNoShow: "After cancellation period / No-Show",
      lateValue: "100% charge",
      paymentLabel: "Payment",
      paymentValue: "Total amount at booking",
    },
    roomDetail: {
      ourRooms: "Our Rooms",
      viewPhotos: "View photos",
      bookDirect: "We look forward to welcoming you on your next stay! Book directly with the hotel and benefit from flexible rates, no hidden third-party fees – with personal service.",
      note: "Please note: Each room varies in size, layout and interior design. Prices depend on the number of guests per room. We do our best to accommodate your individual wishes.",
      bookNow: "Book Now",
      equipment: "Room Equipment",
      hotelTimes: "Hotel Times",
      allRooms: "← View All Rooms",
    },
    homeFAQ: {
      caption: "FAQ",
      heading: "Frequently Asked Questions",
      text: "Here you will find answers to the most common questions about your stay at Hotel Quelle.",
      q1: "What are the check-in and check-out times?",
      a1: "Check-in is from 3:00 PM and check-out is until 11:00 AM. Early check-in or late check-out can be arranged upon request, subject to availability.",
      q2: "Is breakfast included in the room rate?",
      a2: "Yes, a fresh continental breakfast is included in the room rate. Breakfast is served daily from 7:30 to 9:30 AM.",
      q3: "Is there parking available at the hotel?",
      a3: "Yes, we offer free parking for our guests. Please let us know when booking if you are arriving by car.",
      q4: "Is the hotel suitable for families with children?",
      a4: "Absolutely! We have Family Rooms that are ideal for families. Children are welcome and we can provide extra beds upon request.",
      q5: "How far is Bad Ragaz train station?",
      a5: "Bad Ragaz train station is only about a 5-minute walk from the hotel. We can also arrange a transfer from the station.",
      q6: "Can I eat at Esos Grill restaurant if I'm not a hotel guest?",
      a6: "Yes, Esos Grill restaurant is open to both hotel guests and external visitors. Reservations are recommended, especially on weekends.",
    },
    homeLocation: {
      caption: "Location",
      heading: "Bad Ragaz,",
      headingItalic: "Switzerland",
      text: "Bad Ragaz is located in the Canton of St. Gallen in the eastern part of Switzerland. Known for its thermal springs and breathtaking Alpine views, the town offers a perfect combination of nature and culture.",
      travel: "Getting Here",
      byTrain: "By Train",
      trainDesc: "Bad Ragaz Station - 5 min. walk",
      byPlane: "By Plane",
      planeDesc: "Zurich Airport - 1.5 hours",
      byCar: "By Car",
      carDesc: "Highway A13 - Exit Bad Ragaz",
      contactUs: "Contact Us",
    },
    roomData: {
      features: ["Fridge", "Cable & Smart TV", "Private Bathroom", "Hair Dryer", "Hotel Toiletries", "Internet & WiFi", "Safe", "Free Parking"],
      family: {
        amenities: ["Double Bed & Sofa Bed", "Private Bathroom with Bathtub", "Cable & Smart TV", "Free WiFi", "Free Parking"],
        highlight: "Private Balcony",
        highlightSub: "With view of the Tamina",
      },
      triple: {
        amenities: ["Double Bed & Single Bed", "Private Bathroom", "Cable & Smart TV", "Free WiFi", "Free Parking"],
        highlight: "Comfortable Sleeping Area",
        highlightSub: "Space for up to 3 guests",
      },
      twin: {
        amenities: ["Two Single Beds", "Private Bathroom", "Cable & Smart TV", "Free WiFi", "Free Parking"],
        highlight: "Comfortable Sleeping Area",
        highlightSub: "Ideal for 2 guests",
      },
      double: {
        amenities: ["Comfortable Double Bed", "Private Bathroom", "Cable & Smart TV", "Free WiFi", "Free Parking"],
        highlight: "Cozy Sleeping Area",
        highlightSub: "Comfort for 2 guests",
      },
      suite: {
        amenities: ["Double Bed & Single Bed", "Private Bathroom", "Kitchen", "Fireplace", "Balcony"],
        highlight: "Cozy Fireplace",
        highlightSub: "Relaxation on two floors",
      },
    },
    hotelInfo: {
      heading: "Important Hotel Information",
      items: [
        "Kurtax/Tourism Tax CHF 4.60 per person / night",
        "VAT 3.8%",
        "Extra towel for Tamina Therme CHF 5.–",
        "Dog CHF 40.–/day",
        "Complimentary for children under 4 years, including a baby crib",
        "Parking: Free",
        "Important: Hotel parking is available on a first-come, first-served basis (limited availability).",
        "Additional parking is available at Parkhaus Zentrum for approx. CHF 1.–/hour (1–2 minutes' walk).",
        "Complimentary Wireless Internet",
      ] as readonly string[],
      checkOut: "Check-out: 07:00 - 11:00",
      checkIn: "Check-in: 16:00 - 22:00",
      viewRooms: "View Rooms",
    },
  },

  fr: {
    nav: {
      home: "Accueil",
      hotel: "Hôtel",
      rooms: "Chambres",
      restaurant: "Restaurant",
      badRagaz: "Bad Ragaz",
      contact: "Contact",
      bookNow: "Réserver",
    },
    hero: {
      welcome: "Bienvenue à",
      hotelName: "Esos Hotel Quelle,",
      location: "Bad Ragaz",
    },
    ski: {
      title: "Forfait ski inclus",
      subtitle: "à partir de 2 nuits",
      cta: "En savoir plus",
    },
    homeNews: {
      caption: "Actualités",
      heading: "Dernières nouvelles de l'Hôtel Quelle",
      comingSoon: "Les actualités arrivent bientôt – restez à l'écoute !",
    },
    homeAbout: {
      caption: "Bienvenue",
      heading1: "Hotel Quelle",
      heading2: "Bad Ragaz",
      text: "Situé dans le centre historique de Bad Ragaz, l'Hôtel Quelle offre une combinaison parfaite de tradition suisse et d'hospitalité chaleureuse. Avec une riche histoire et un service excellent, nous sommes le choix idéal pour les voyageurs en quête de confort et d'authenticité.",
      location: "Bad Ragaz",
      country: "Suisse",
      reception: "Réception",
      cta: "En Savoir Plus",
      aboutHeading: "À Propos de l'Hôtel",
      shortText: "Bienvenue dans notre charmant hôtel-boutique avec des chambres et appartements confortables dans un cadre paisible au cœur de Bad Ragaz, directement au bord de la Tamina.",
    },
    guestfriend: {
      heading: "Découvrez maintenant toutes les informations, offres",
      heading2: "et conseils pour vos vacances",
      partner: "En coopération avec",
      scan: "Scanner ou cliquer ici",
    },
    badRagazSection: {
      heading: "Nature Pure",
      caption: "Découvrez nos environs",
      subtitle: "Entouré par les Alpes en Suisse orientale, dans la région de Heidiland",
      values: "Nos valeurs fondamentales : Un petit-déjeuner frais chaque jour, les plus hauts standards de propreté et un confort optimal pour tous les hôtes.",
      description: "Bad Ragaz est un lieu renommé en Suisse orientale, représenté par Heidiland Tourisme. Vous y trouverez une source thermale ancestrale, une destination spa relaxante et une station thermale, entourée de montagnes majestueuses et d'une belle nature en toutes saisons.",
      cta: "En savoir plus sur Bad Ragaz",
      winter: "Hiver",
      spring: "Printemps",
      summer: "Été",
      autumn: "Automne",
    },
    homeRooms: {
      caption: "Hébergement",
      heading: "Nos Chambres",
      text: "Choisissez la chambre idéale pour votre séjour confortable.",
      moreDetails: "Plus de Détails",
      familyRoom: "Chambre Familiale Standard",
      tripleRoom: "Chambre Triple Standard",
      twinRoom: "Economy Chambre Double",
      doubleRoom: "Chambre Double Standard",
      suite: "Suite",
    },
    homeApartments: {
      caption: "Séjour Longue Durée",
      heading: "Appartements",
      bookTitle: "Réservez votre appartement directement chez nous",
      bookText: "Nous proposons des appartements à la location, sous réserve de disponibilité. Chaque appartement a un agencement individuel et une taille différente. Les réservations doivent être effectuées directement auprès de l'hôtel.",
      contactLink: "Contactez-nous pour plus d'informations et disponibilités.",
      amenities: [
        "2–3 Chambres",
        "Petite Kitchenette",
        "TV Câble & Smart",
        "Salle de Bain",
        "Sèche-cheveux",
        "Produits de Toilette",
        "Internet Wi-Fi",
        "Coffre-fort",
      ],
    },
    homeGallery: {
      caption: "Aperçus",
      heading: "Vues de l'Hôtel",
    },
    homeDining: {
      caption: "Cuisine & Boissons",
      heading: "Expérience Culinaire",
      text: "Du petit-déjeuner continental au grill traditionnel – savourez nos expériences culinaires spéciales.",
      breakfastTitle: "Petit-déjeuner Buffet & Dîner",
      breakfastText: "Nous servons chaque jour un petit-déjeuner continental frais pour tous nos hôtes dans notre belle salle à manger.",
      breakfastTime: "Petit-déjeuner – 7h30 à 9h30",
      dinnerTime: "Dîner – 17h30 à 19h30",
      grillTitle: "Esos Grill",
      grillText: "Esos Grill est un restaurant relié à l'hôtel.",
      grillHighlight: "De la Tradition Balkanique à la Tradition Suisse",
      grillDesc: "Esos Grill propose une variété de grillades et de plats comfort food pour tous les goûts.",
      grillHours: "Ouvert de 17h30 à 22h00",
      cta: "Découvrir le Restaurant",
      cafeHeading: "Café chaleureux servant de délicieux plats et boissons",
    },
    footer: {
      home: "Accueil",
      about: "À Propos",
      rooms: "Chambres",
      restaurant: "Restaurant",
      contact: "Contact",
      impressum: "Mentions Légales",
      datenschutz: "Politique de Confidentialité",
      navigation: "Navigation",
      followUs: "Suivez-nous",
      legal: "Mentions Légales",
      rights: "Tous droits réservés.",
      designBy: "Design & Développement par",
      reservation: "Réservation",
    },
    footerContact: {
      caption: "Votre séjour commence ici",
      heading: "Contactez-nous",
      whatsappAction: "Envoyer un message",
      address: "Adresse :",
      namePlaceholder: "Votre Nom",
      emailLabel: "E-mail",
      phoneLabel: "Téléphone",
      subjectLabel: "Sujet",
      subjectPlaceholder: "Choisir le sujet",
      messageLabel: "Message",
      messagePlaceholder: "Comment pouvons-nous vous aider ?",
      sending: "Envoi en cours...",
      sendMessage: "Envoyer le Message",
      privacyText: "En soumettant, vous acceptez notre",
      privacyLink: "Politique de Confidentialité",
      subjects: {
        reservation: "Réservation de Chambre",
        restaurant: "Réservation de Table",
        group: "Réservation de Groupe",
        event: "Événement / Conférence",
        feedback: "Commentaires",
        other: "Autre",
      },
      toastTitle: "Message envoyé !",
      toastDesc: "Merci pour votre message. Nous vous répondrons bientôt.",
    },
    subpageHeroes: {
      about: { title: "À Propos", subtitle: "Notre Hôtel" },
      rooms: { title: "Nos Chambres", subtitle: "Confort & Détente" },
      restaurant: { title: "Restaurant", subtitle: "Expérience Culinaire" },
      badRagaz: { title: "Bad Ragaz", subtitle: "Village Spa – Suisse" },
      contact: { title: "Contact", subtitle: "Nous nous réjouissons de vous accueillir" },
      familyRoom: { title: "Chambre Familiale Standard", subtitle: "Standard Family Room" },
      tripleRoom: { title: "Chambre Triple Standard", subtitle: "Standard Triple Room" },
      twinRoom: { title: "Economy Chambre Double / Lits Jumeaux avec Salle de Bain Commune", subtitle: "Economy Double Room / Twin Room with Shared Bathroom" },
      doubleRoom: { title: "Chambre Double Standard", subtitle: "Standard Double Room" },
      suite: { title: "Suite", subtitle: "Suite" },
      bookingPolicy: { title: "Conditions de Réservation", subtitle: "Booking Policy" },
    },
    about: {
      storyCaption: "Notre Histoire",
      storyHeading1: "Un Chez-soi",
      storyHeading2: "loin de Chez-soi –",
      storyHeading3: "depuis 1918",
      storyText: "Notre charmant hôtel-boutique accueille des voyageurs du monde entier depuis plus d'un siècle. Avec sa riche histoire et son atmosphère familiale, l'hôtel offre un mélange unique de charme traditionnel et de confort moderne.",
      founded: "Fondé",
      yearsHospitality: "Ans d'Hospitalité",
      historicCaption: "Hotel Quelle – Photo historique, vers 1918",
      filmQuote: "Nous sommes fiers d'avoir participé au film suisso-américain",
      filmTitle: "Sew Torn",
      filmQuote2: "– un héritage cinématographique qui apporte une touche spéciale à nos murs chargés d'histoire.",
      filmWelcome: "Que ce soit pour la détente, le bien-être ou l'inspiration – Bienvenue à l'Hôtel Quelle",
      locationCaption: "Notre Emplacement",
      locationHeading: "Niché dans un cadre paisible et idyllique",
      locationHeadingItalic: "le long de la Tamina historique",
      taminaschlucht: "Gorges de la Tamina",
      taminaschluchtDesc: "À quelques pas se trouve l'entrée des spectaculaires gorges de la Tamina.",
      thermalSource: "Source Thermale Historique",
      thermalSourceDesc: "Une promenade pittoresque de 45 minutes mène à la grotte de la source thermale historique.",
      taminaTherme: "Tamina Therme",
      taminaThermeDesc: "Les célèbres Tamina Therme ne sont qu'à 3 minutes à pied de notre hôtel.",
      centralLocation: "Emplacement Central",
      centralLocationDesc: "Au cœur de Bad Ragaz – à seulement une heure à l'est de Zurich et à 10 minutes à pied de la gare.",
      amenitiesHeading: "Fraîchement rénovés, nos chambres et appartements offrent une élégance chaleureuse pour un séjour vraiment confortable.",
      modernFurnishing: "Ameublement Moderne",
      modernFurnishingDesc: "Nos appartements disposent d'un mobilier moderne alliant style et confort.",
      privateBalconies: "Balcons Privés",
      privateBalconiesDesc: "Chaque appartement dispose d'un balcon privé avec espace extérieur calme.",
      roomService: "Service de Chambre",
      roomServiceDesc: "Un service de chambre professionnel assure la propreté quotidienne.",
      wifiTitle: "Internet & WiFi",
      wifiDesc: "Le WiFi haut débit est disponible – idéal pour le travail, la navigation ou les appels vidéo.",
      wellnessTitle: "Centre de Bien-être",
      wellnessDesc: "Les hôtes peuvent visiter les Tamina Therme, à seulement 500m. Nos hôtes bénéficient d'une réduction de 10%.",
      productsTitle: "Produits de Toilette",
      productsDesc: "Chaque appartement est équipé de produits de toilette de haute qualité.",
      galleryCaption: "Galerie de l'Hôtel",
      galleryHeading: "Découvrez notre hôtel à Bad Ragaz",
    },
    roomsPage: {
      caption: "Hébergement",
      heading: "Nos Chambres",
      text: "Choisissez la chambre idéale pour votre séjour confortable. Toutes les chambres comprennent le petit-déjeuner gratuit, WiFi, Smart TV et parking gratuit.",
      familyRoom: "Chambre Familiale Standard",
      familyRoomDesc: "Notre plus grande chambre – spécialement conçue pour les familles.",
      tripleRoom: "Chambre Triple Standard",
      tripleRoomDesc: "Idéale pour les groupes d'amis ou les petites familles avec trois lits confortables.",
      twinRoom: "Economy Chambre Double",
      twinRoomDesc: "Parfaite pour les collègues ou amis – deux lits séparés pour une flexibilité maximale.",
      doubleRoom: "Chambre Double Standard",
      doubleRoomDesc: "Le choix idéal pour les couples – confortable et élégante avec le charme suisse traditionnel.",
      suite: "Suite",
      suiteDesc: "Notre suite spacieuse avec cuisine, cheminée, balcon et espace nuit séparé sur deux étages.",
      upTo: "Jusqu'à",
      persons: "personnes",
      learnMore: "En savoir plus",
      bookDirect: "Réservez directement auprès de l'hôtel et bénéficiez de tarifs flexibles et d'un service personnalisé.",
      inquireNow: "Demander maintenant",
      bookingPolicy: "Conditions de Réservation",
    },
    restaurantPage: {
      caption: "Cuisine & Boissons", heading: "Expérience Culinaire",
      text: "Découvrez les différentes saveurs que nous proposons – du grill balkanique traditionnel au petit-déjeuner continental suisse.",
      everyMorning: "Chaque Matin", continentalBreakfast: "Petit-déjeuner Continental",
      breakfastText: "Chaque jour, nous servons un petit-déjeuner continental frais pour tous les hôtes de l'hôtel.",
      breakfastTime: "Petit-déjeuner : 7h30 - 9h30", dinnerTime: "Dîner : 17h30 - 19h30",
      ourGarden: "Notre Jardin", grillGarden: "Grill Garden",
      grillGardenText: "Dans notre beau jardin, les hôtes peuvent profiter de boissons fraîches et de mets délicieux en pleine nature.",
      grillGardenText2: "L'ambiance extérieure est parfaite pour les chaudes journées d'été.",
      charcoalGrill: "Grill au Charbon", relaxedAmbience: "Ambiance Détendue",
      freshDrinks: "Boissons Fraîches", greenArea: "Espace Vert",
      openingHours: "Heures d'ouverture :", weatherOpen: "Ouvert par beau temps",
      ourRestaurant: "Notre Restaurant",
      esosGrillDesc: "Esos Grill est un restaurant directement relié à l'hôtel.",
      balkanToSwiss: "De la Tradition Balkanique à la Tradition Suisse",
      esosGrillDesc2: "Esos Grill propose une variété de grillades et de plats comfort food.",
      seats: "40+ Places",
      guestInfo: "Informations pour les Hôtes",
      tableReservation: "Réservation de Table",
      tableReservationDesc: "Pour les grands groupes, nous recommandons une réservation préalable.",
      reserveTable: "Réserver une Table",
      nonGuests: "Pour les Non-Résidents",
      nonGuestsDesc: "Esos Grill est également ouvert aux visiteurs non hébergés à l'hôtel. Bienvenue !",
      drinksBeer: "Boissons & Bières",
      drinksBeerDesc: "Nous offrons une large sélection de bières suisses et de boissons rafraîchissantes.",
    },
    contactPage: {
      caption: "Contact", heading: "Nous nous réjouissons de vous accueillir",
      text: "Vous avez des questions ou souhaitez faire une réservation ? Contactez-nous – notre équipe est à votre disposition.",
      mobile: "Mobile", email: "E-mail", whatsapp: "WhatsApp", sendMessage: "Envoyer un message",
      msgHeading: "Envoyer un Message",
      firstName: "Prénom", lastName: "Nom", phone: "Téléphone",
      subject: "Sujet", selectSubject: "Choisir le sujet",
      checkIn: "Arrivée", checkOut: "Départ", guests: "Invités", count: "Nombre",
      person: "Personne", persons: "Personnes", message: "Message",
      messagePlaceholder: "Comment pouvons-nous vous aider ?",
      sending: "Envoi en cours...", send: "Envoyer le Message",
      privacyText: "En soumettant ce formulaire, vous acceptez notre",
      privacyLink: "Politique de Confidentialité",
      address: "Adresse", openInMaps: "Ouvrir dans Google Maps",
      receptionTitle: "Réception", receptionHours: "Heures d'ouverture",
      receptionValue: "07:00 - 22:00", checkInTime: "16:00 - 22:00", checkOutTime: "07:00 - 11:00",
      paymentTitle: "Paiement",
      paymentMethods: "Espèces (CHF, EUR), Visa, MasterCard, American Express, Virement bancaire",
      subjects: {
        reservation: "Réservation de Chambre", restaurant: "Réservation de Table",
        group: "Réservation de Groupe", event: "Événement / Conférence",
        feedback: "Commentaires / Suggestions", other: "Autre",
      },
      toastTitle: "Message envoyé !", toastDesc: "Merci pour votre message. Nous vous répondrons bientôt.",
    },
    badRagazPage: {
      regionCaption: "Notre Région", heading: "Bad Ragaz", spaVillage: "– Village Spa",
      intro1: "Bad Ragaz est une petite ville avec une longue et riche histoire dans le canton de Saint-Gall, dans la région orientale de la Suisse.",
      intro2: "Ici se trouve la Tamina, qui mène aux gorges de la Tamina à Altes Bad Pfäfers – avec une source chaude naturelle découverte par Paracelse.",
      intro3: "De nombreuses personnalités et équipes sportives ont visité Bad Ragaz, dont Roger Federer, le FC Liverpool et Borussia Dortmund.",
      accessInfo: "Bad Ragaz n'est qu'à environ une heure de Davos et Saint-Moritz. Accessible depuis les pays voisins par voiture ou transports publics.",
      mapCaption: "Bad Ragaz – Canton de Saint-Gall, Suisse",
      discoverCaption: "Découvrir", discoverHeading: "Ce que Bad Ragaz a à offrir",
      taminaTherme: "Tamina Therme", taminaThermeDesc: "Les célèbres Tamina Therme sont à 3 minutes à pied.",
      pizol: "Pizol – Ski & Randonnée", pizolDesc: "La station de ski et paradis de randonnée Pizol.",
      taminaschlucht: "Gorges de la Tamina", taminaschluchtDesc: "L'entrée des spectaculaires gorges de la Tamina.",
      golf: "Terrains de Golf", golfDesc: "De magnifiques terrains de golf dans un décor montagneux impressionnant.",
      shopping: "Shopping & Culture", shoppingDesc: "Expositions de sculptures, restaurants, outlets et bien plus.",
      transport: "Connexions Centrales", transportDesc: "Trains directs depuis Amsterdam, Bruxelles, Francfort, Hambourg, Cologne et Paris.",
      impressionsCaption: "Impressions", impressionsHeading: "Bad Ragaz & Environs",
      videoCaption: "Film Image", videoHeading: "Découvrir Bad Ragaz",
    },
    bookingPolicyPage: {
      caption: "Esos Hotel Quelle", heading: "Conditions de Réservation",
      text: "La transparence est importante pour nous. Vous trouverez ici toutes les informations sur le paiement, l'annulation et les réservations de groupe.",
      payment: "Paiement", paymentText: "Esos Hotel Quelle facture le montant total au moment de la réservation.",
      cancellation: "Annulation & Remboursement",
      cancellationText: "Les réservations directes sont entièrement remboursables si annulées au moins",
      cancellationBold: "3 jours avant l'arrivée avant 16h00", cancellationText2: ".",
      cancellationNoShow: "Aucun remboursement ne sera effectué après la période d'annulation gratuite ou en cas de non-présentation.",
      groupBookings: "Réservations de Groupe",
      groupText: "Les réservations de groupe (plus de 2 chambres) peuvent être annulées gratuitement jusqu'à",
      groupBold: "7 jours avant l'arrivée", groupText2: ".",
      importantNote: "Note Importante",
      importantText: "Après la période d'annulation gratuite, le client sera facturé",
      importantBold: "100 % du montant du séjour", importantText2: ".",
      overview: "Aperçu",
      singleFree: "Réservation individuelle – annulation gratuite", singleValue: "Jusqu'à 3 jours avant, 16h00",
      groupFree: "Réservation de groupe – annulation gratuite", groupValue: "Jusqu'à 7 jours avant",
      lateNoShow: "Après période d'annulation / Non-présentation", lateValue: "100 % de frais",
      paymentLabel: "Paiement", paymentValue: "Montant total à la réservation",
    },
    roomDetail: {
      ourRooms: "Nos Chambres", viewPhotos: "Voir les photos",
      bookDirect: "Nous nous réjouissons de vous accueillir ! Réservez directement auprès de l'hôtel et bénéficiez de tarifs flexibles, sans frais cachés – avec un service personnalisé.",
      note: "Veuillez noter : Chaque chambre varie en taille, disposition et décoration intérieure.",
      bookNow: "Réserver Maintenant", equipment: "Équipement de la Chambre",
      hotelTimes: "Horaires de l'Hôtel", allRooms: "← Voir Toutes les Chambres",
    },
    homeFAQ: {
      caption: "FAQ",
      heading: "Questions Fréquentes",
      text: "Vous trouverez ici les réponses aux questions les plus fréquentes concernant votre séjour à l'Hôtel Quelle.",
      q1: "Quels sont les horaires d'arrivée et de départ ?",
      a1: "L'arrivée est à partir de 15h00 et le départ jusqu'à 11h00. Une arrivée anticipée ou un départ tardif peut être arrangé sur demande, sous réserve de disponibilité.",
      q2: "Le petit-déjeuner est-il inclus dans le tarif ?",
      a2: "Oui, un petit-déjeuner continental frais est inclus. Le petit-déjeuner est servi tous les jours de 7h30 à 9h30.",
      q3: "Y a-t-il un parking disponible à l'hôtel ?",
      a3: "Oui, nous offrons un parking gratuit pour nos hôtes. Veuillez nous informer lors de la réservation si vous arrivez en voiture.",
      q4: "L'hôtel est-il adapté aux familles avec enfants ?",
      a4: "Absolument ! Nous avons des chambres familiales idéales pour les familles. Les enfants sont les bienvenus et nous pouvons fournir des lits supplémentaires sur demande.",
      q5: "À quelle distance se trouve la gare de Bad Ragaz ?",
      a5: "La gare de Bad Ragaz est à environ 5 minutes à pied de l'hôtel. Nous pouvons également organiser un transfert depuis la gare.",
      q6: "Puis-je manger au restaurant Esos Grill sans être client ?",
      a6: "Oui, le restaurant Esos Grill est ouvert aux clients de l'hôtel et aux visiteurs externes. Les réservations sont recommandées, surtout le week-end.",
    },
    homeLocation: {
      caption: "Emplacement",
      heading: "Bad Ragaz,",
      headingItalic: "Suisse",
      text: "Bad Ragaz se trouve dans le canton de Saint-Gall, dans la partie orientale de la Suisse. Connue pour ses sources thermales et ses vues alpines à couper le souffle, la ville offre une combinaison parfaite de nature et de culture.",
      travel: "Comment Venir",
      byTrain: "En Train",
      trainDesc: "Gare de Bad Ragaz - 5 min. à pied",
      byPlane: "En Avion",
      planeDesc: "Aéroport de Zurich - 1h30",
      byCar: "En Voiture",
      carDesc: "Autoroute A13 - Sortie Bad Ragaz",
      contactUs: "Contactez-nous",
    },
    roomData: {
      features: ["Réfrigérateur", "TV Câble & Smart", "Salle de Bain Privée", "Sèche-cheveux", "Produits de Toilette", "Internet & WiFi", "Coffre-fort", "Parking Gratuit"],
      family: {
        amenities: ["Lit Double & Canapé-lit", "Salle de Bain avec Baignoire", "TV Câble & Smart", "WiFi Gratuit", "Parking Gratuit"],
        highlight: "Balcon Privé",
        highlightSub: "Avec vue sur la Tamina",
      },
      triple: {
        amenities: ["Lit Double & Lit Simple", "Salle de Bain Privée", "TV Câble & Smart", "WiFi Gratuit", "Parking Gratuit"],
        highlight: "Espace Nuit Confortable",
        highlightSub: "Place pour 3 personnes",
      },
      twin: {
        amenities: ["Deux Lits Simples", "Salle de Bain Privée", "TV Câble & Smart", "WiFi Gratuit", "Parking Gratuit"],
        highlight: "Espace Nuit Confortable",
        highlightSub: "Idéal pour 2 personnes",
      },
      double: {
        amenities: ["Lit Double Confortable", "Salle de Bain Privée", "TV Câble & Smart", "WiFi Gratuit", "Parking Gratuit"],
        highlight: "Espace Nuit Douillet",
        highlightSub: "Confort pour 2 personnes",
      },
      suite: {
        amenities: ["Lit Double & Lit Simple", "Salle de Bain Privée", "Cuisine", "Cheminée", "Balcon"],
        highlight: "Cheminée Chaleureuse",
        highlightSub: "Détente sur deux étages",
      },
    },
    hotelInfo: {
      heading: "Informations Importantes sur l'Hôtel",
      items: [
        "Taxe de séjour CHF 4.60 par personne / nuit",
        "TVA 3.8%",
        "Serviette supplémentaire pour Tamina Therme CHF 5.–",
        "Chien CHF 40.–/jour",
        "Gratuit pour les enfants de moins de 4 ans, lit bébé inclus",
        "Parking : Gratuit",
        "Important : Le parking de l'hôtel est disponible selon le principe premier arrivé, premier servi (disponibilité limitée).",
        "Parking supplémentaire au Parkhaus Zentrum pour env. CHF 1.–/heure (1–2 minutes à pied).",
        "Internet sans fil gratuit",
      ] as readonly string[],
      checkOut: "Check-out : 07:00 - 11:00",
      checkIn: "Check-in : 16:00 - 22:00",
      viewRooms: "Voir les chambres",
    },
  },

  es: {
    nav: {
      home: "Inicio",
      hotel: "Hotel",
      rooms: "Habitaciones",
      restaurant: "Restaurante",
      badRagaz: "Bad Ragaz",
      contact: "Contacto",
      bookNow: "Reservar",
    },
    hero: {
      welcome: "Bienvenido a",
      hotelName: "Esos Hotel Quelle,",
      location: "Bad Ragaz",
    },
    ski: {
      title: "Forfait de esquí incluido",
      subtitle: "desde 2 noches",
      cta: "Más información",
    },
    homeNews: {
      caption: "Novedades",
      heading: "Últimas noticias del Hotel Quelle",
      comingSoon: "¡Las novedades llegarán pronto – estén atentos!",
    },
    homeAbout: {
      caption: "Bienvenido",
      heading1: "Hotel Quelle",
      heading2: "Bad Ragaz",
      text: "Ubicado en el centro histórico de Bad Ragaz, el Hotel Quelle ofrece una combinación perfecta de tradición suiza y cálida hospitalidad. Con una rica historia y un servicio excelente, somos la elección ideal para viajeros que buscan comodidad y autenticidad.",
      location: "Bad Ragaz",
      country: "Suiza",
      reception: "Recepción",
      cta: "Más Información",
      aboutHeading: "Sobre el Hotel",
      shortText: "Bienvenido a nuestro encantador hotel boutique con cómodas habitaciones y apartamentos en una ubicación tranquila en el corazón de Bad Ragaz, a orillas del río Tamina.",
    },
    guestfriend: {
      heading: "Descubra ahora toda la información, ofertas",
      heading2: "y consejos para sus vacaciones",
      partner: "En cooperación con",
      scan: "Escanear o hacer clic aquí",
    },
    badRagazSection: {
      heading: "Naturaleza Pura",
      caption: "Descubra nuestro entorno",
      subtitle: "Rodeado de los Alpes en el este de Suiza, en la región de Heidiland",
      values: "Nuestros valores fundamentales: Un desayuno fresco cada día, los más altos estándares de limpieza y confort óptimo para todos los huéspedes.",
      description: "Bad Ragaz es un lugar renombrado en el este de Suiza. Aquí encontrará una antigua fuente termal, un destino de spa relajante y un balneario, rodeado de majestuosas montañas y hermosa naturaleza en todas las estaciones.",
      cta: "Más sobre Bad Ragaz",
      winter: "Invierno",
      spring: "Primavera",
      summer: "Verano",
      autumn: "Otoño",
    },
    homeRooms: {
      caption: "Alojamiento",
      heading: "Nuestras Habitaciones",
      text: "Elija la habitación adecuada para su estancia confortable.",
      moreDetails: "Más Detalles",
      familyRoom: "Habitación Familiar Estándar",
      tripleRoom: "Habitación Triple Estándar",
      twinRoom: "Economy Habitación Doble",
      doubleRoom: "Habitación Doble Estándar",
      suite: "Suite",
    },
    homeApartments: {
      caption: "Estancia Prolongada",
      heading: "Apartamentos",
      bookTitle: "Reserve su apartamento directamente con nosotros",
      bookText: "Ofrecemos apartamentos en alquiler, sujeto a disponibilidad. Cada apartamento tiene un diseño individual y un tamaño diferente. Las reservas deben realizarse directamente con el hotel.",
      contactLink: "Contáctenos para más información y disponibilidad.",
      amenities: [
        "2–3 Dormitorios",
        "Pequeña Cocina",
        "TV Cable & Smart",
        "Baño",
        "Secador de Pelo",
        "Artículos de Tocador",
        "Internet Wi-Fi",
        "Caja Fuerte",
      ],
    },
    homeGallery: {
      caption: "Perspectivas",
      heading: "Vistas del Hotel",
    },
    homeDining: {
      caption: "Cocina & Bebidas",
      heading: "Experiencia Culinaria",
      text: "Desde el desayuno continental hasta la parrilla tradicional – disfrute de nuestras experiencias culinarias especiales.",
      breakfastTitle: "Desayuno Buffet & Cena",
      breakfastText: "Servimos un desayuno continental fresco todos los días para todos nuestros huéspedes en nuestro hermoso comedor.",
      breakfastTime: "Desayuno – 7:30 a 9:30",
      dinnerTime: "Cena – 17:30 a 19:30",
      grillTitle: "Esos Grill",
      grillText: "Esos Grill es un restaurante conectado al hotel.",
      grillHighlight: "De la Tradición Balcánica a la Tradición Suiza",
      grillDesc: "Esos Grill ofrece una variedad de platos a la parrilla y comida rápida reconfortante para todos los gustos.",
      grillHours: "Abierto de 17:30 a 22:00",
      cta: "Descubrir Restaurante",
      cafeHeading: "Acogedor café que sirve deliciosa comida y bebidas",
    },
    footer: {
      home: "Inicio", about: "Sobre Nosotros", rooms: "Habitaciones",
      restaurant: "Restaurante", contact: "Contacto",
      impressum: "Aviso Legal", datenschutz: "Política de Privacidad",
      navigation: "Navegación", followUs: "Síguenos", legal: "Legal",
      rights: "Todos los derechos reservados.", designBy: "Diseño y Desarrollo por",
      reservation: "Reservación",
    },
    footerContact: {
      caption: "Su estancia comienza aquí", heading: "Contáctenos",
      whatsappAction: "Enviar mensaje", address: "Dirección:",
      namePlaceholder: "Su Nombre", emailLabel: "Correo", phoneLabel: "Teléfono",
      subjectLabel: "Asunto", subjectPlaceholder: "Elegir asunto",
      messageLabel: "Mensaje", messagePlaceholder: "¿Cómo podemos ayudarle?",
      sending: "Enviando...", sendMessage: "Enviar Mensaje",
      privacyText: "Al enviar, acepta nuestra", privacyLink: "Política de Privacidad",
      subjects: {
        reservation: "Reserva de Habitación", restaurant: "Reserva de Mesa",
        group: "Reserva de Grupo", event: "Evento / Conferencia",
        feedback: "Comentarios", other: "Otro",
      },
      toastTitle: "¡Mensaje enviado!", toastDesc: "Gracias por su mensaje. Nos pondremos en contacto pronto.",
    },
    subpageHeroes: {
      about: { title: "Sobre Nosotros", subtitle: "Nuestro Hotel" },
      rooms: { title: "Nuestras Habitaciones", subtitle: "Confort & Relajación" },
      restaurant: { title: "Restaura / Dos Camas con Baño Compartido", subtitle: "Economy Double Room / Twin Room with Shared Bathrulinaria" },
      badRagaz: { title: "Bad Ragaz", subtitle: "Villa Spa – Suiza" },
      contact: { title: "Contacto", subtitle: "Esperamos su visita" },
      familyRoom: { title: "Habitación Familiar Estándar", subtitle: "Standard Family Room" },
      tripleRoom: { title: "Habitación Triple Estándar", subtitle: "Standard Triple Room" },
      twinRoom: { title: "Economy Habitación Doble / Dos Camas con Baño Compartido", subtitle: "Economy Double Room / Twin Room with Shared Bathroom" },
      doubleRoom: { title: "Habitación Doble Estándar", subtitle: "Standard Double Room" },
      suite: { title: "Suite", subtitle: "Suite" },
      bookingPolicy: { title: "Política de Reservas", subtitle: "Booking Policy" },
    },
    about: {
      storyCaption: "Nuestra Historia",
      storyHeading1: "Un Hogar Lejos",
      storyHeading2: "del Hogar –",
      storyHeading3: "desde 1918",
      storyText: "Nuestro encantador hotel boutique da la bienvenida a viajeros de todo el mundo desde hace más de un siglo. Con su rica historia y ambiente familiar, el hotel ofrece una mezcla única de encanto tradicional y confort moderno.",
      founded: "Fundado", yearsHospitality: "Años de Hospitalidad",
      historicCaption: "Hotel Quelle – Fotografía histórica, circa 1918",
      filmQuote: "Estamos orgullosos de haber participado en la película suizo-americana",
      filmTitle: "Sew Torn",
      filmQuote2: "– un legado cinematográfico que añade un toque especial a nuestros muros históricos.",
      filmWelcome: "Ya sea para relajarse, bienestar o inspiración – Bienvenido al Hotel Quelle",
      locationCaption: "Nuestra Ubicación",
      locationHeading: "Ubicado en un entorno pacífico e idílico",
      locationHeadingItalic: "a lo largo del histórico Tamina",
      taminaschlucht: "Garganta de Tamina", taminaschluchtDesc: "A pocos pasos se encuentra la entrada a la impresionante Garganta de Tamina.",
      thermalSource: "Fuente Termal Histórica", thermalSourceDesc: "Un pintoresco paseo de 45 minutos lleva a la cueva de la fuente termal histórica.",
      taminaTherme: "Tamina Therme", taminaThermeDesc: "Las famosas Tamina Therme están a solo 3 minutos a pie de nuestro hotel.",
      centralLocation: "Ubicación Central", centralLocationDesc: "En el corazón de Bad Ragaz – a solo una hora al este de Zúrich y a 10 minutos a pie de la estación de tren.",
      amenitiesHeading: "Recién renovados, nuestras habitaciones y apartamentos ofrecen una elegancia acogedora para una estancia verdaderamente confortable.",
      modernFurnishing: "Mobiliario Moderno", modernFurnishingDesc: "Nuestros apartamentos cuentan con mobiliario moderno que combina estilo con confort.",
      privateBalconies: "Balcones Privados", privateBalconiesDesc: "Cada apartamento tiene un balcón privado con zona exterior tranquila.",
      roomService: "Servicio de Habitaciones", roomServiceDesc: "El servicio de habitaciones profesional garantiza la limpieza diaria.",
      wifiTitle: "Internet & WiFi", wifiDesc: "WiFi de alta velocidad disponible – ideal para trabajo, navegación o videollamadas.",
      wellnessTitle: "Centro de Bienestar", wellnessDesc: "Los huéspedes pueden visitar las Tamina Therme a 500m. Nuestros huéspedes reciben un 10% de descuento.",
      productsTitle: "Artículos de Tocador", productsDesc: "Cada apartamento está equipado con artículos de tocador de alta calidad.",
      galleryCaption: "Galería del Hotel", galleryHeading: "Descubra nuestro hotel en Bad Ragaz",
    },
    roomsPage: {
      caption: "Alojamiento", heading: "Nuestras Habitaciones",
      text: "Elija la habitación adecuada para su estancia confortable. Todas las habitaciones incluyen desayuno gratuito, WiFi, Smart TV y estacionamiento gratuito.",
      familyRoom: "Habitación Familiar Estándar", familyRoomDesc: "Nuestra habitación más grande – diseñada especialmente para familias.",
      tripleRoom: "Habitación Triple Estándar", tripleRoomDesc: "Ideal para grupos de amigos o familias pequeñas con tres camas cómodas.",
      twinRoom: "Economy Habitación Doble", twinRoomDesc: "Perfecta para colegas o amigos – dos camas separadas para máxima flexibilidad.",
      doubleRoom: "Habitación Doble Estándar", doubleRoomDesc: "La elección ideal para parejas – cómoda y elegante con encanto suizo tradicional.",
      suite: "Suite", suiteDesc: "Nuestra amplia suite con cocina, chimenea, balcón y zona de descanso separada en dos plantas.",
      upTo: "Hasta", persons: "personas", learnMore: "Más información",
      bookDirect: "Reserve directamente con el hotel y benefíciese de tarifas flexibles y servicio personalizado.",
      inquireNow: "Consultar Ahora", bookingPolicy: "Política de Reservas",
    },
    restaurantPage: {
      caption: "Cocina & Bebidas", heading: "Experiencia Culinaria",
      text: "Descubra los diferentes sabores que ofrecemos – desde la parrilla balkánica tradicional hasta el desayuno continental suizo.",
      everyMorning: "Cada Mañana", continentalBreakfast: "Desayuno Continental",
      breakfastText: "Cada día servimos un desayuno continental fresco para todos los huéspedes del hotel.",
      breakfastTime: "Desayuno: 7:30 - 9:30", dinnerTime: "Cena: 17:30 - 19:30",
      ourGarden: "Nuestro Jardín", grillGarden: "Grill Garden",
      grillGardenText: "En nuestro hermoso jardín, los huéspedes pueden disfrutar de bebidas frescas y comida deliciosa en la naturaleza.",
      grillGardenText2: "El ambiente exterior es perfecto para los cálidos días de verano.",
      charcoalGrill: "Parrilla de Carbón", relaxedAmbience: "Ambiente Relajado",
      freshDrinks: "Bebidas Frescas", greenArea: "Zona Verde",
      openingHours: "Horario:", weatherOpen: "Abierto con buen tiempo",
      ourRestaurant: "Nuestro Restaurante",
      esosGrillDesc: "Esos Grill es un restaurante directamente conectado al hotel.",
      balkanToSwiss: "De la Tradición Balcánica a la Tradición Suiza",
      esosGrillDesc2: "Esos Grill ofrece una variedad de platos a la parrilla y comfort food.",
      seats: "40+ Asientos", guestInfo: "Información para Huéspedes",
      tableReservation: "Reserva de Mesa", tableReservationDesc: "Para grupos grandes recomendamos reservar con antelación.",
      reserveTable: "Reservar Mesa",
      nonGuests: "Para No Huéspedes", nonGuestsDesc: "Esos Grill también está abierto para visitantes que no se alojan en el hotel. ¡Bienvenidos!",
      drinksBeer: "Bebidas & Cerveza", drinksBeerDesc: "Ofrecemos una amplia selección de cervezas suizas y bebidas refrescantes.",
    },
    contactPage: {
      caption: "Contacto", heading: "Esperamos su visita",
      text: "¿Tiene preguntas o desea hacer una reserva? Contáctenos – nuestro equipo está encantado de ayudarle.",
      mobile: "Móvil", email: "Correo", whatsapp: "WhatsApp", sendMessage: "Enviar mensaje",
      msgHeading: "Enviar Mensaje", firstName: "Nombre", lastName: "Apellido",
      phone: "Teléfono", subject: "Asunto", selectSubject: "Seleccionar asunto",
      checkIn: "Llegada", checkOut: "Salida", guests: "Huéspedes", count: "Cantidad",
      person: "Persona", persons: "Personas", message: "Mensaje",
      messagePlaceholder: "¿Cómo podemos ayudarle?",
      sending: "Enviando...", send: "Enviar Mensaje",
      privacyText: "Al enviar este formulario, acepta nuestra", privacyLink: "Política de Privacidad",
      address: "Dirección", openInMaps: "Abrir en Google Maps",
      receptionTitle: "Recepción", receptionHours: "Horario",
      receptionValue: "07:00 - 22:00", checkInTime: "16:00 - 22:00", checkOutTime: "07:00 - 11:00",
      paymentTitle: "Pago", paymentMethods: "Efectivo (CHF, EUR), Visa, MasterCard, American Express, Transferencia bancaria",
      subjects: {
        reservation: "Reserva de Habitación", restaurant: "Reserva de Mesa",
        group: "Reserva de Grupo", event: "Evento / Conferencia",
        feedback: "Comentarios / Sugerencias", other: "Otro",
      },
      toastTitle: "¡Mensaje enviado!", toastDesc: "Gracias por su mensaje. Nos pondremos en contacto pronto.",
    },
    badRagazPage: {
      regionCaption: "Nuestra Región", heading: "Bad Ragaz", spaVillage: "– Villa Spa",
      intro1: "Bad Ragaz es una pequeña ciudad con una larga y rica historia en el cantón de San Galo, en la región oriental de Suiza.",
      intro2: "Aquí se encuentra el Tamina, que conduce a la Garganta de Tamina en Altes Bad Pfäfers – con una fuente termal natural descubierta por Paracelso.",
      intro3: "Muchas personalidades y equipos deportivos han visitado Bad Ragaz, incluyendo Roger Federer, el FC Liverpool y Borussia Dortmund.",
      accessInfo: "Bad Ragaz está a solo una hora de Davos y St. Moritz. Accesible desde los países vecinos por coche o transporte público.",
      mapCaption: "Bad Ragaz – Cantón de San Galo, Suiza",
      discoverCaption: "Descubrir", discoverHeading: "Lo que Bad Ragaz ofrece",
      taminaTherme: "Tamina Therme", taminaThermeDesc: "Las famosas Tamina Therme están a 3 minutos a pie.",
      pizol: "Pizol – Esquí & Senderismo", pizolDesc: "La estación de esquí y paraíso de senderismo Pizol.",
      taminaschlucht: "Garganta de Tamina", taminaschluchtDesc: "La entrada a la impresionante Garganta de Tamina.",
      golf: "Campos de Golf", golfDesc: "Hermosos campos de golf en un impresionante entorno montañoso.",
      shopping: "Compras & Cultura", shoppingDesc: "Exposiciones de esculturas, restaurantes, outlets y mucho más.",
      transport: "Conexiones Centrales", transportDesc: "Trenes directos desde Ámsterdam, Bruselas, Fráncfort, Hamburgo, Colonia y París.",
      impressionsCaption: "Impresiones", impressionsHeading: "Bad Ragaz y Alrededores",
      videoCaption: "Video Promocional", videoHeading: "Descubrir Bad Ragaz",
    },
    bookingPolicyPage: {
      caption: "Esos Hotel Quelle", heading: "Política de Reservas",
      text: "La transparencia es importante para nosotros. Aquí encontrará toda la información sobre pagos, cancelaciones y reservas de grupo.",
      payment: "Pago", paymentText: "Esos Hotel Quelle cobra el importe total al huésped en el momento de la reserva.",
      cancellation: "Cancelación & Reembolso",
      cancellationText: "Las reservas directas son totalmente reembolsables si se cancelan al menos",
      cancellationBold: "3 días antes de la llegada antes de las 16:00", cancellationText2: ".",
      cancellationNoShow: "No se realizará reembolso después del período de cancelación gratuita o en caso de no presentarse.",
      groupBookings: "Reservas de Grupo",
      groupText: "Las reservas de grupo (más de 2 habitaciones) pueden cancelarse gratuitamente hasta",
      groupBold: "7 días antes de la llegada", groupText2: ".",
      importantNote: "Nota Importante",
      importantText: "Después del período de cancelación gratuita, se cobrará al huésped",
      importantBold: "el 100% del importe de la estancia", importantText2: ".",
      overview: "Resumen",
      singleFree: "Reserva individual – cancelación gratuita", singleValue: "Hasta 3 días antes, 16:00",
      groupFree: "Reserva de grupo – cancelación gratuita", groupValue: "Hasta 7 días antes",
      lateNoShow: "Después del período / No presentarse", lateValue: "100% de cargo",
      paymentLabel: "Pago", paymentValue: "Importe total en la reserva",
    },
    roomDetail: {
      ourRooms: "Nuestras Habitaciones", viewPhotos: "Ver fotos",
      bookDirect: "¡Esperamos darle la bienvenida en su próxima estancia! Reserve directamente con el hotel y benefíciese de tarifas flexibles, sin cargos ocultos – con servicio personalizado.",
      note: "Por favor tenga en cuenta: Cada habitación varía en tamaño, distribución y decoración interior.",
      bookNow: "Reservar Ahora", equipment: "Equipamiento de la Habitación",
      hotelTimes: "Horarios del Hotel", allRooms: "← Ver Todas las Habitaciones",
    },
    homeFAQ: {
      caption: "FAQ",
      heading: "Preguntas Frecuentes",
      text: "Aquí encontrará respuestas a las preguntas más frecuentes sobre su estancia en el Hotel Quelle.",
      q1: "¿Cuáles son los horarios de check-in y check-out?",
      a1: "El check-in es a partir de las 15:00 y el check-out hasta las 11:00. Se puede organizar un check-in anticipado o check-out tardío bajo petición, sujeto a disponibilidad.",
      q2: "¿Está el desayuno incluido en la tarifa?",
      a2: "Sí, un desayuno continental fresco está incluido en la tarifa. El desayuno se sirve diariamente de 7:30 a 9:30.",
      q3: "¿Hay aparcamiento disponible en el hotel?",
      a3: "Sí, ofrecemos aparcamiento gratuito para nuestros huéspedes. Por favor infórmenos al reservar si llega en coche.",
      q4: "¿Es el hotel adecuado para familias con niños?",
      a4: "¡Absolutamente! Tenemos habitaciones familiares ideales para familias. Los niños son bienvenidos y podemos proporcionar camas adicionales bajo petición.",
      q5: "¿A qué distancia está la estación de tren de Bad Ragaz?",
      a5: "La estación de tren de Bad Ragaz está a solo 5 minutos a pie del hotel. También podemos organizar un traslado desde la estación.",
      q6: "¿Puedo comer en Esos Grill sin ser huésped del hotel?",
      a6: "Sí, el restaurante Esos Grill está abierto tanto para huéspedes del hotel como para visitantes externos. Se recomiendan reservas, especialmente los fines de semana.",
    },
    homeLocation: {
      caption: "Ubicación",
      heading: "Bad Ragaz,",
      headingItalic: "Suiza",
      text: "Bad Ragaz se encuentra en el cantón de San Galo, en la parte oriental de Suiza. Conocida por sus fuentes termales y sus impresionantes vistas alpinas, la ciudad ofrece una combinación perfecta de naturaleza y cultura.",
      travel: "Cómo Llegar",
      byTrain: "En Tren",
      trainDesc: "Estación Bad Ragaz - 5 min. a pie",
      byPlane: "En Avión",
      planeDesc: "Aeropuerto de Zúrich - 1.5 horas",
      byCar: "En Coche",
      carDesc: "Autopista A13 - Salida Bad Ragaz",
      contactUs: "Contáctenos",
    },
    roomData: {
      features: ["Refrigerador", "TV Cable & Smart", "Baño Privado", "Secador de Pelo", "Artículos de Tocador", "Internet & WiFi", "Caja Fuerte", "Estacionamiento Gratuito"],
      family: {
        amenities: ["Cama Doble & Sofá Cama", "Baño Privado con Bañera", "TV Cable & Smart", "WiFi Gratuito", "Estacionamiento Gratuito"],
        highlight: "Balcón Privado",
        highlightSub: "Con vista al Tamina",
      },
      triple: {
        amenities: ["Cama Doble & Cama Individual", "Baño Privado", "TV Cable & Smart", "WiFi Gratuito", "Estacionamiento Gratuito"],
        highlight: "Área de Descanso Confortable",
        highlightSub: "Espacio para 3 huéspedes",
      },
      twin: {
        amenities: ["Dos Camas Individuales", "Baño Privado", "TV Cable & Smart", "WiFi Gratuito", "Estacionamiento Gratuito"],
        highlight: "Área de Descanso Confortable",
        highlightSub: "Ideal para 2 huéspedes",
      },
      double: {
        amenities: ["Cama Doble Confortable", "Baño Privado", "TV Cable & Smart", "WiFi Gratuito", "Estacionamiento Gratuito"],
        highlight: "Área de Descanso Acogedora",
        highlightSub: "Confort para 2 huéspedes",
      },
      suite: {
        amenities: ["Cama Doble & Cama Individual", "Baño Privado", "Cocina", "Chimenea", "Balcón"],
        highlight: "Chimenea Acogedora",
        highlightSub: "Relajación en dos plantas",
      },
    },
    hotelInfo: {
      heading: "Información Importante del Hotel",
      items: [
        "Tasa turística CHF 4.60 por persona / noche",
        "IVA 3.8%",
        "Toalla extra para Tamina Therme CHF 5.–",
        "Perro CHF 40.–/día",
        "Gratuito para niños menores de 4 años, incluida cuna",
        "Aparcamiento: Gratis",
        "Importante: El aparcamiento del hotel está disponible por orden de llegada (disponibilidad limitada).",
        "Aparcamiento adicional en Parkhaus Zentrum por aprox. CHF 1.–/hora (1–2 minutos a pie).",
        "Internet inalámbrico gratuito",
      ] as readonly string[],
      checkOut: "Check-out: 07:00 - 11:00",
      checkIn: "Check-in: 16:00 - 22:00",
      viewRooms: "Ver habitaciones",
    },
  },

  it: {
    nav: {
      home: "Home",
      hotel: "Hotel",
      rooms: "Camere",
      restaurant: "Ristorante",
      badRagaz: "Bad Ragaz",
      contact: "Contatto",
      bookNow: "Prenota",
    },
    hero: {
      welcome: "Benvenuti al",
      hotelName: "Esos Hotel Quelle,",
      location: "Bad Ragaz",
    },
    ski: {
      title: "Skipass incluso",
      subtitle: "da 2 pernottamenti",
      cta: "Scopri di più",
    },
    homeNews: {
      caption: "Novità",
      heading: "Ultime notizie dall'Hotel Quelle",
      comingSoon: "Le novità arriveranno presto – restate sintonizzati!",
    },
    homeAbout: {
      caption: "Benvenuti",
      heading1: "Hotel Quelle",
      heading2: "Bad Ragaz",
      text: "Situato nel centro storico di Bad Ragaz, l'Hotel Quelle offre una combinazione perfetta di tradizione svizzera e calorosa ospitalità. Con una ricca storia e un servizio eccellente, siamo la scelta ideale per i viaggiatori in cerca di comfort e autenticità.",
      location: "Bad Ragaz",
      country: "Svizzera",
      reception: "Reception",
      cta: "Scopri di Più",
      aboutHeading: "L'Hotel",
      shortText: "Benvenuti nel nostro affascinante boutique hotel con camere e appartamenti confortevoli in posizione tranquilla nel cuore di Bad Ragaz, direttamente sulle rive del fiume Tamina.",
    },
    guestfriend: {
      heading: "Scoprite ora tutte le informazioni, offerte",
      heading2: "e consigli per la vostra vacanza",
      partner: "In collaborazione con",
      scan: "Scansiona o clicca qui",
    },
    badRagazSection: {
      heading: "Natura Pura",
      caption: "Scoprite i nostri dintorni",
      subtitle: "Circondati dalle Alpi nella Svizzera orientale, nella regione di Heidiland",
      values: "I nostri valori fondamentali: Una colazione fresca ogni giorno, i più alti standard di pulizia e comfort ottimale per tutti gli ospiti.",
      description: "Bad Ragaz è un rinomato luogo nella Svizzera orientale, rappresentato da Heidiland Turismo. Qui troverete un'antica sorgente termale, una destinazione spa rilassante e una stazione termale, circondata da montagne maestose e bella natura in tutte le stagioni.",
      cta: "Scopri di più su Bad Ragaz",
      winter: "Inverno",
      spring: "Primavera",
      summer: "Estate",
      autumn: "Autunno",
    },
    homeRooms: {
      caption: "Alloggio",
      heading: "Le Nostre Camere",
      text: "Scegliete la camera giusta per il vostro soggiorno confortevole.",
      moreDetails: "Più Dettagli",
      familyRoom: "Camera Familiare Standard",
      tripleRoom: "Camera Tripla Standard",
      twinRoom: "Economy Camera Doppia",
      doubleRoom: "Camera Doppia Standard",
      suite: "Suite",
    },
    homeApartments: {
      caption: "Soggiorno Prolungato",
      heading: "Appartamenti",
      bookTitle: "Prenotate il vostro appartamento direttamente con noi",
      bookText: "Offriamo appartamenti in affitto, in base alla disponibilità. Ogni appartamento ha una disposizione individuale e dimensioni diverse. Le prenotazioni devono essere effettuate direttamente con l'hotel.",
      contactLink: "Contattateci per maggiori informazioni e disponibilità.",
      amenities: [
        "2–3 Camere da letto",
        "Piccolo Angolo Cottura",
        "TV via Cavo & Smart",
        "Bagno",
        "Asciugacapelli",
        "Prodotti da Bagno",
        "Internet Wi-Fi",
        "Cassaforte",
      ],
    },
    homeGallery: {
      caption: "Impressioni",
      heading: "Vedute dell'Hotel",
    },
    homeDining: {
      caption: "Cucina & Bevande",
      heading: "Esperienza Culinaria",
      text: "Dalla colazione continentale alla grigliata tradizionale – godetevi le nostre esperienze culinarie speciali.",
      breakfastTitle: "Colazione a Buffet & Cena",
      breakfastText: "Serviamo ogni giorno una colazione continentale fresca per tutti i nostri ospiti nella nostra bella sala da pranzo.",
      breakfastTime: "Colazione – 7:30 alle 9:30",
      dinnerTime: "Cena – 17:30 alle 19:30",
      grillTitle: "Esos Grill",
      grillText: "Esos Grill è un ristorante collegato all'hotel.",
      grillHighlight: "Dalla Tradizione Balcanica alla Tradizione Svizzera",
      grillDesc: "Esos Grill offre una varietà di piatti alla griglia e comfort food per tutti i gusti.",
      grillHours: "Aperto dalle 17:30 alle 22:00",
      cta: "Scopri il Ristorante",
      cafeHeading: "Accogliente caffè che serve deliziosi piatti e bevande",
    },
    footer: {
      home: "Home",
      about: "Chi Siamo",
      rooms: "Camere",
      restaurant: "Ristorante",
      contact: "Contatto",
      impressum: "Note Legali",
      datenschutz: "Privacy",
      navigation: "Navigazione",
      followUs: "Seguici",
      legal: "Legale",
      rights: "Tutti i diritti riservati.",
      designBy: "Design & Sviluppo di",
      reservation: "Prenotazione",
    },
    footerContact: {
      caption: "Il vostro soggiorno inizia qui",
      heading: "Contattateci",
      whatsappAction: "Invia messaggio",
      address: "Indirizzo:",
      namePlaceholder: "Il Vostro Nome",
      emailLabel: "E-mail",
      phoneLabel: "Telefono",
      subjectLabel: "Oggetto",
      subjectPlaceholder: "Scegliere oggetto",
      messageLabel: "Messaggio",
      messagePlaceholder: "Come possiamo aiutarvi?",
      sending: "Invio in corso...",
      sendMessage: "Invia Messaggio",
      privacyText: "Inviando, accettate la nostra",
      privacyLink: "Informativa sulla Privacy",
      subjects: {
        reservation: "Prenotazione Camera",
        restaurant: "Prenotazione Tavolo",
        group: "Prenotazione di Gruppo",
        event: "Evento / Conferenza",
        feedback: "Feedback",
        other: "Altro",
      },
      toastTitle: "Messaggio inviato!",
      toastDesc: "Grazie per il vostro messaggio. Vi risponderemo presto.",
    },
    subpageHeroes: {
      about: { title: "Chi Siamo", subtitle: "Il Nostro Hotel" },
      rooms: { title: "Le Nostre Camere", subtitle: "Comfort & Relax" },
      restaurant: { title: "Ristorante", subtitle: "Esperienza Culinaria" },
      badRagaz: { title: "Bad Ragaz", subtitle: "Villaggio Spa – Svizzera" },
      contact: { title: "Contat / Due Letti con Bagno in Comune", subtitle: "Economy Double Room / Twin Room with Shared Bathrora di accogliervi" },
      familyRoom: { title: "Camera Familiare Standard", subtitle: "Standard Family Room" },
      tripleRoom: { title: "Camera Tripla Standard", subtitle: "Standard Triple Room" },
      twinRoom: { title: "Economy Camera Doppia / Due Letti con Bagno in Comune", subtitle: "Economy Double Room / Twin Room with Shared Bathroom" },
      doubleRoom: { title: "Camera Doppia Standard", subtitle: "Standard Double Room" },
      suite: { title: "Suite", subtitle: "Suite" },
      bookingPolicy: { title: "Condizioni di Prenotazione", subtitle: "Booking Policy" },
    },
    about: {
      storyCaption: "La Nostra Storia",
      storyHeading1: "Una Casa Lontano",
      storyHeading2: "da Casa –",
      storyHeading3: "dal 1918",
      storyText: "Il nostro affascinante boutique hotel accoglie viaggiatori da tutto il mondo da oltre un secolo. Con la sua ricca storia e l'atmosfera familiare, l'hotel offre un mix unico di fascino tradizionale e comfort moderno.",
      founded: "Fondato",
      yearsHospitality: "Anni di Ospitalità",
      historicCaption: "Hotel Quelle – Foto storica, circa 1918",
      filmQuote: "Siamo orgogliosi di aver partecipato al film svizzero-americano",
      filmTitle: "Sew Torn",
      filmQuote2: "– un'eredità cinematografica che dona un tocco speciale alle nostre mura storiche.",
      filmWelcome: "Che sia per relax, benessere o ispirazione – Benvenuti all'Hotel Quelle",
      locationCaption: "La Nostra Posizione",
      locationHeading: "Immerso in un ambiente tranquillo e idilliaco",
      locationHeadingItalic: "lungo la storica Tamina",
      taminaschlucht: "Gola della Tamina",
      taminaschluchtDesc: "A pochi passi si trova l'ingresso della spettacolare Gola della Tamina.",
      thermalSource: "Sorgente Termale Storica",
      thermalSourceDesc: "Una pittoresca passeggiata di 45 minuti porta alla grotta della sorgente termale storica.",
      taminaTherme: "Tamina Therme",
      taminaThermeDesc: "Le famose Tamina Therme sono a soli 3 minuti a piedi dal nostro hotel.",
      centralLocation: "Posizione Centrale",
      centralLocationDesc: "Nel cuore di Bad Ragaz – a solo un'ora a est di Zurigo e a 10 minuti a piedi dalla stazione ferroviaria.",
      amenitiesHeading: "Recentemente rinnovate, le nostre camere e appartamenti offrono un'eleganza accogliente per un soggiorno veramente confortevole.",
      modernFurnishing: "Arredamento Moderno",
      modernFurnishingDesc: "I nostri appartamenti dispongono di arredamento moderno che combina stile e comfort.",
      privateBalconies: "Balconi Privati",
      privateBalconiesDesc: "Ogni appartamento ha un balcone privato con zona esterna tranquilla.",
      roomService: "Servizio in Camera",
      roomServiceDesc: "Il servizio in camera professionale garantisce la pulizia quotidiana.",
      wifiTitle: "Internet & WiFi",
      wifiDesc: "WiFi ad alta velocità disponibile – ideale per lavoro, navigazione o videochiamate.",
      wellnessTitle: "Centro Benessere",
      wellnessDesc: "Gli ospiti possono visitare le Tamina Therme a 500m. I nostri ospiti ricevono uno sconto del 10%.",
      productsTitle: "Prodotti da Bagno",
      productsDesc: "Ogni appartamento è dotato di prodotti da bagno di alta qualità.",
      galleryCaption: "Galleria dell'Hotel",
      galleryHeading: "Scoprite il nostro hotel a Bad Ragaz",
    },
    roomsPage: {
      caption: "Alloggio",
      heading: "Le Nostre Camere",
      text: "Scegliete la camera giusta per il vostro soggiorno confortevole. Tutte le camere includono colazione gratuita, WiFi, Smart TV e parcheggio gratuito.",
      familyRoom: "Camera Familiare Standard",
      familyRoomDesc: "La nostra camera più grande – progettata appositamente per le famiglie.",
      tripleRoom: "Camera Tripla Standard",
      tripleRoomDesc: "Ideale per gruppi di amici o piccole famiglie con tre letti confortevoli.",
      twinRoom: "Economy Camera Doppia",
      twinRoomDesc: "Perfetta per colleghi o amici – due letti separati per la massima flessibilità.",
      doubleRoom: "Camera Doppia Standard",
      doubleRoomDesc: "La scelta ideale per le coppie – confortevole ed elegante con il fascino svizzero tradizionale.",
      suite: "Suite",
      suiteDesc: "La nostra spaziosa suite con cucina, camino, balcone e zona notte separata su due piani.",
      upTo: "Fino a",
      persons: "persone",
      learnMore: "Scopri di più",
      bookDirect: "Prenotate direttamente con l'hotel e approfittate di tariffe flessibili e servizio personalizzato.",
      inquireNow: "Richiedi Ora",
      bookingPolicy: "Condizioni di Prenotazione",
    },
    restaurantPage: {
      caption: "Cucina & Bevande",
      heading: "Esperienza Culinaria",
      text: "Scoprite i diversi sapori che offriamo – dalla grigliata balcanica tradizionale alla colazione continentale svizzera.",
      everyMorning: "Ogni Mattina",
      continentalBreakfast: "Colazione Continentale",
      breakfastText: "Ogni giorno serviamo una colazione continentale fresca per tutti gli ospiti dell'hotel.",
      breakfastTime: "Colazione: 7:30 - 9:30",
      dinnerTime: "Cena: 17:30 - 19:30",
      ourGarden: "Il Nostro Giardino",
      grillGarden: "Grill Garden",
      grillGardenText: "Nel nostro bellissimo giardino, gli ospiti possono gustare bevande fresche e piatti deliziosi nella natura.",
      grillGardenText2: "L'atmosfera all'aperto è perfetta per le calde giornate estive.",
      charcoalGrill: "Griglia a Carbone",
      relaxedAmbience: "Atmosfera Rilassata",
      freshDrinks: "Bevande Fresche",
      greenArea: "Area Verde",
      openingHours: "Orari di apertura:",
      weatherOpen: "Aperto con bel tempo",
      ourRestaurant: "Il Nostro Ristorante",
      esosGrillDesc: "Esos Grill è un ristorante direttamente collegato all'hotel.",
      balkanToSwiss: "Dalla Tradizione Balcanica alla Tradizione Svizzera",
      esosGrillDesc2: "Esos Grill offre una varietà di piatti alla griglia e comfort food.",
      seats: "40+ Posti",
      guestInfo: "Informazioni per gli Ospiti",
      tableReservation: "Prenotazione Tavolo",
      tableReservationDesc: "Per gruppi più grandi consigliamo una prenotazione anticipata.",
      reserveTable: "Prenota Tavolo",
      nonGuests: "Per Non Ospiti",
      nonGuestsDesc: "Esos Grill è aperto anche ai visitatori non alloggiati in hotel. Benvenuti!",
      drinksBeer: "Bevande & Birra",
      drinksBeerDesc: "Offriamo un'ampia selezione di birre svizzere e bevande rinfrescanti.",
    },
    contactPage: {
      caption: "Contatto",
      heading: "Non vediamo l'ora di accogliervi",
      text: "Avete domande o desiderate effettuare una prenotazione? Contattateci – il nostro team è a vostra disposizione.",
      mobile: "Cellulare",
      email: "E-mail",
      whatsapp: "WhatsApp",
      sendMessage: "Invia messaggio",
      msgHeading: "Invia Messaggio",
      firstName: "Nome",
      lastName: "Cognome",
      phone: "Telefono",
      subject: "Oggetto",
      selectSubject: "Seleziona oggetto",
      checkIn: "Check-in",
      checkOut: "Check-out",
      guests: "Ospiti",
      count: "Numero",
      person: "Persona",
      persons: "Persone",
      message: "Messaggio",
      messagePlaceholder: "Come possiamo aiutarvi?",
      sending: "Invio in corso...",
      send: "Invia Messaggio",
      privacyText: "Inviando questo modulo, accettate la nostra",
      privacyLink: "Informativa sulla Privacy",
      address: "Indirizzo",
      openInMaps: "Apri in Google Maps",
      receptionTitle: "Reception",
      receptionHours: "Orari di apertura",
      receptionValue: "07:00 - 22:00",
      checkInTime: "16:00 - 22:00",
      checkOutTime: "07:00 - 11:00",
      paymentTitle: "Pagamento",
      paymentMethods: "Contanti (CHF, EUR), Visa, MasterCard, American Express, Bonifico bancario",
      subjects: {
        reservation: "Prenotazione Camera",
        restaurant: "Prenotazione Tavolo",
        group: "Prenotazione di Gruppo",
        event: "Evento / Conferenza",
        feedback: "Feedback / Suggerimenti",
        other: "Altro",
      },
      toastTitle: "Messaggio inviato!",
      toastDesc: "Grazie per il vostro messaggio. Vi risponderemo presto.",
    },
    badRagazPage: {
      regionCaption: "La Nostra Regione",
      heading: "Bad Ragaz",
      spaVillage: "– Villaggio Spa",
      intro1: "Bad Ragaz è una piccola città con una lunga e ricca storia nel Cantone di San Gallo, nella regione orientale della Svizzera.",
      intro2: "Qui si trova la Tamina, che conduce alla Gola della Tamina ad Altes Bad Pfäfers – con una sorgente termale naturale scoperta da Paracelso.",
      intro3: "Molte personalità e squadre sportive hanno visitato Bad Ragaz, tra cui Roger Federer, il FC Liverpool e il Borussia Dortmund.",
      accessInfo: "Bad Ragaz è a solo un'ora da Davos e St. Moritz. Raggiungibile dai paesi vicini in auto o con i trasporti pubblici.",
      mapCaption: "Bad Ragaz – Cantone di San Gallo, Svizzera",
      discoverCaption: "Scoprire",
      discoverHeading: "Cosa offre Bad Ragaz",
      taminaTherme: "Tamina Therme",
      taminaThermeDesc: "Le famose Tamina Therme sono a 3 minuti a piedi.",
      pizol: "Pizol – Sci & Escursioni",
      pizolDesc: "La stazione sciistica e paradiso escursionistico Pizol.",
      taminaschlucht: "Gola della Tamina",
      taminaschluchtDesc: "L'ingresso della spettacolare Gola della Tamina.",
      golf: "Campi da Golf",
      golfDesc: "Bellissimi campi da golf in un impressionante scenario montano.",
      shopping: "Shopping & Cultura",
      shoppingDesc: "Mostre di sculture, ristoranti, outlet e molto altro.",
      transport: "Collegamenti Centrali",
      transportDesc: "Treni diretti da Amsterdam, Bruxelles, Francoforte, Amburgo, Colonia e Parigi.",
      impressionsCaption: "Impressioni",
      impressionsHeading: "Bad Ragaz e Dintorni",
      videoCaption: "Video Promozionale",
      videoHeading: "Scoprire Bad Ragaz",
    },
    bookingPolicyPage: {
      caption: "Esos Hotel Quelle",
      heading: "Condizioni di Prenotazione",
      text: "La trasparenza è importante per noi. Qui trovate tutte le informazioni su pagamento, cancellazione e prenotazioni di gruppo.",
      payment: "Pagamento",
      paymentText: "Esos Hotel Quelle addebita l'importo totale al momento della prenotazione.",
      cancellation: "Cancellazione & Rimborso",
      cancellationText: "Le prenotazioni dirette sono completamente rimborsabili se cancellate almeno",
      cancellationBold: "3 giorni prima dell'arrivo entro le 16:00",
      cancellationText2: ".",
      cancellationNoShow: "Nessun rimborso dopo il periodo di cancellazione gratuita o in caso di mancata presentazione.",
      groupBookings: "Prenotazioni di Gruppo",
      groupText: "Le prenotazioni di gruppo (più di 2 camere) possono essere cancellate gratuitamente fino a",
      groupBold: "7 giorni prima dell'arrivo",
      groupText2: ".",
      importantNote: "Nota Importante",
      importantText: "Dopo il periodo di cancellazione gratuita, all'ospite verrà addebitato",
      importantBold: "il 100% dell'importo del soggiorno",
      importantText2: ".",
      overview: "Riepilogo",
      singleFree: "Prenotazione singola – cancellazione gratuita",
      singleValue: "Fino a 3 giorni prima, 16:00",
      groupFree: "Prenotazione di gruppo – cancellazione gratuita",
      groupValue: "Fino a 7 giorni prima",
      lateNoShow: "Dopo il periodo / Mancata presentazione",
      lateValue: "100% di addebito",
      paymentLabel: "Pagamento",
      paymentValue: "Importo totale alla prenotazione",
    },
    roomDetail: {
      ourRooms: "Le Nostre Camere",
      viewPhotos: "Vedi foto",
      bookDirect: "Non vediamo l'ora di darvi il benvenuto al vostro prossimo soggiorno! Prenotate direttamente con l'hotel e approfittate di tariffe flessibili, senza costi nascosti – con servizio personalizzato.",
      note: "Si prega di notare: Ogni camera varia per dimensioni, disposizione e arredamento.",
      bookNow: "Prenota Ora",
      equipment: "Dotazione della Camera",
      hotelTimes: "Orari dell'Hotel",
      allRooms: "← Vedi Tutte le Camere",
    },
    homeFAQ: {
      caption: "FAQ",
      heading: "Domande Frequenti",
      text: "Qui trovate le risposte alle domande più frequenti sul vostro soggiorno all'Hotel Quelle.",
      q1: "Quali sono gli orari di check-in e check-out?",
      a1: "Il check-in è dalle 15:00 e il check-out entro le 11:00. Check-in anticipato o check-out posticipato possono essere organizzati su richiesta, in base alla disponibilità.",
      q2: "La colazione è inclusa nella tariffa?",
      a2: "Sì, una colazione continentale fresca è inclusa nella tariffa. La colazione viene servita tutti i giorni dalle 7:30 alle 9:30.",
      q3: "C'è un parcheggio disponibile all'hotel?",
      a3: "Sì, offriamo parcheggio gratuito per i nostri ospiti. Vi preghiamo di informarci al momento della prenotazione se arrivate in auto.",
      q4: "L'hotel è adatto alle famiglie con bambini?",
      a4: "Assolutamente! Abbiamo camere familiari ideali per le famiglie. I bambini sono i benvenuti e possiamo fornire letti supplementari su richiesta.",
      q5: "Quanto dista la stazione ferroviaria di Bad Ragaz?",
      a5: "La stazione ferroviaria di Bad Ragaz è a soli 5 minuti a piedi dall'hotel. Possiamo anche organizzare un trasferimento dalla stazione.",
      q6: "Posso mangiare all'Esos Grill senza essere ospite dell'hotel?",
      a6: "Sì, il ristorante Esos Grill è aperto sia agli ospiti dell'hotel che ai visitatori esterni. Le prenotazioni sono consigliate, soprattutto nei fine settimana.",
    },
    homeLocation: {
      caption: "Posizione",
      heading: "Bad Ragaz,",
      headingItalic: "Svizzera",
      text: "Bad Ragaz si trova nel Cantone di San Gallo, nella parte orientale della Svizzera. Conosciuta per le sue sorgenti termali e le mozzafiato vedute alpine, la città offre una combinazione perfetta di natura e cultura.",
      travel: "Come Arrivare",
      byTrain: "In Treno",
      trainDesc: "Stazione Bad Ragaz - 5 min. a piedi",
      byPlane: "In Aereo",
      planeDesc: "Aeroporto di Zurigo - 1,5 ore",
      byCar: "In Auto",
      carDesc: "Autostrada A13 - Uscita Bad Ragaz",
      contactUs: "Contattateci",
    },
    roomData: {
      features: ["Frigorifero", "TV via Cavo & Smart", "Bagno Privato", "Asciugacapelli", "Prodotti da Bagno", "Internet & WiFi", "Cassaforte", "Parcheggio Gratuito"],
      family: {
        amenities: ["Letto Matrimoniale & Divano Letto", "Bagno Privato con Vasca", "TV via Cavo & Smart", "WiFi Gratuito", "Parcheggio Gratuito"],
        highlight: "Balcone Privato",
        highlightSub: "Con vista sulla Tamina",
      },
      triple: {
        amenities: ["Letto Matrimoniale & Letto Singolo", "Bagno Privato", "TV via Cavo & Smart", "WiFi Gratuito", "Parcheggio Gratuito"],
        highlight: "Zona Notte Confortevole",
        highlightSub: "Spazio per 3 ospiti",
      },
      twin: {
        amenities: ["Due Letti Singoli", "Bagno Privato", "TV via Cavo & Smart", "WiFi Gratuito", "Parcheggio Gratuito"],
        highlight: "Zona Notte Confortevole",
        highlightSub: "Ideale per 2 ospiti",
      },
      double: {
        amenities: ["Letto Matrimoniale Confortevole", "Bagno Privato", "TV via Cavo & Smart", "WiFi Gratuito", "Parcheggio Gratuito"],
        highlight: "Zona Notte Accogliente",
        highlightSub: "Comfort per 2 ospiti",
      },
      suite: {
        amenities: ["Letto Matrimoniale & Letto Singolo", "Bagno Privato", "Cucina", "Camino", "Balcone"],
        highlight: "Camino Accogliente",
        highlightSub: "Relax su due piani",
      },
    },
    hotelInfo: {
      heading: "Informazioni Importanti sull'Hotel",
      items: [
        "Tassa di soggiorno CHF 4.60 per persona / notte",
        "IVA 3.8%",
        "Asciugamano extra per Tamina Therme CHF 5.–",
        "Cane CHF 40.–/giorno",
        "Gratuito per bambini sotto i 4 anni, inclusa culla",
        "Parcheggio: Gratuito",
        "Importante: Il parcheggio dell'hotel è disponibile in base all'ordine di arrivo (disponibilità limitata).",
        "Parcheggio aggiuntivo al Parkhaus Zentrum per ca. CHF 1.–/ora (1–2 minuti a piedi).",
        "Internet wireless gratuito",
      ] as readonly string[],
      checkOut: "Check-out: 07:00 - 11:00",
      checkIn: "Check-in: 16:00 - 22:00",
      viewRooms: "Vedi camere",
    },
  },
} as const;
